import React, { useEffect, useState, useRef } from 'react';
import { Button, message } from 'antd';
import axios from 'axios';
import ComposeSection from '../ComposeSection';
import Spinner from '../Spinner';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/index';
import AllShowCase from '../AllShowCase';
import { MenuItem, FormControl, Select, ListSubheader, TextField } from '@mui/material';
import { Link } from 'react-router-dom';
import NewAvatarHeader from '../NewAvatarHeader';
import MyDesign from '../MyDesign';
import Referal from '../Referal';
import Pose from '../Pose';
import NewPricing from '../NewPricing';
import Style from '../Style';
import Photographer from '../Photographer';
import HeaderSticky from '../HeaderSticky';
import { styled } from '@mui/material/styles';
import MainEditor from '../SmartEditor/MainEditor';
import { Eraser, Sparkles } from 'lucide-react';
import { UPSCALE_MODEL, VIRTUAL_STAGING_MODEL, REMOVE_OBJECTS_MODEL } from '../../constants/model';
import { RowContainer } from '../SmartEditor/components/SidePanel/LabelTitle';
import { Slider } from '../SmartEditor/components/ui/slider';
import { v4 as uuidv4 } from 'uuid';
import { debounce } from 'lodash';
import Feedback from '../Feedback';
import { useStore } from '../SmartEditor/lib/states';

const APP_URL_V1 = process.env.REACT_APP_APP_URL;
const APP_URL_V2 = process.env.REACT_APP_APP_URL_V2;
const APP_URL_V3 = process.env.REACT_APP_APP_URL_V3;
const APP_URL_V4 = process.env.REACT_APP_APP_URL_V4;

const photographerStyle = 'photographer_style';
const photographerPose = 'photographer_pose';
const photographerRemodeling = 'photographer_remodeling';

const modes = {
  pro: 'Pro',
  basic: 'Basic',
};

const MAX_WIDTH = 768;

const results = [
  {
    value: 1,
    label: 'one',
  },
  {
    value: 4,
    label: 'four',
  },
];

const ageItems = [];
for (let age = 18; age <= 100; age++) {
  ageItems.push({
    value: age,
    label: age,
  });
}

const NewSelect = styled(({ darkMode, ...props }) => <Select {...props} />)(({ darkMode }) => ({
  textTransform: 'none',
  fontSize: 16,
  fontFamily: 'inherit',
  backgroundColor: 'transparent',
  color: '#5d5d5d',
  background: darkMode ? '#5d5d5d' : '#fff',
}));

const badWordsString = process.env.REACT_APP_BAD_WORDS || '';
const badWordsArray = badWordsString.split(',').map(word => word.trim());
const forbiddenWordsSet = new Set(badWordsArray.map(word => word.toLowerCase()));

const containsBadWord = (text) => {
  const words = text.toLowerCase().split(/\s+/);
  return words.some(word => forbiddenWordsSet.has(word));
};

const NewHome = ({ firebase, setUser }) => {
  const [userData, setUserData] = useState({});
  const [jobsList, setJobsList] = useState([]);
  const [posesList, setPosesList] = useState([]);
  const [uploadedPosesList, setUploadedPosesList] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  const [mode, setMode] = useState(modes.pro); //Set default is PRO
  const [isShowPricing, setIsShowPricing] = useState(false);
  const [isShowPose, setIsShowPose] = useState(false);
  const [isShowBackground, setIsShowBackground] = useState(false);
  const [isShowStyle, setIsShowStyle] = useState(false);
  const [isShowPhotographer, setIsShowPhotographer] = useState(false);
  const [isSpinning, setIsSpinning] = useState(true);
  const fileInputRef = useRef(null);
  const [imageSrc, setImageSrc] = useState('');
  const [poseSrc, setPoseSrc] = useState('');
  const [poseUrl, setPoseUrl] = useState('');
  const [backgroundSrc, setBackgroundSrc] = useState('');
  const [styleSrc, setStyleSrc] = useState('');
  const [photographerSrc, setPhotographerSrc] = useState('');
  const [photographerName, setPhotographerName] = useState('');
  const [photographerCode, setPhotographerCode] = useState('');
  const [file, setFile] = useState('');
  const [fileInfo, setFileInfo] = useState(null);
  const [currentPoses, setCurrentPoses] = useState(null);
  const [backgrounds, setBackgrounds] = useState(null);
  const [styles, setStyles] = useState('');
  const [backgroundName, setBackgroundName] = useState(null);
  const [backgroundCode, setBackgroundCode] = useState(null);
  const [styleName, setStyleName] = useState(null);
  const [styleCode, setStyleCode] = useState('');
  const [currentRoomType, setCurrentRoomType] = useState('');
  const [currentStyle, setCurrentStyle] = useState('');
  const [currentResult, setCurrentResult] = useState(1);
  const [currentJob, setCurrentJob] = useState(null);
  const [showGenFillEditor, setShowGenFillEditor] = useState(false);
  const [showUpgradeResolution, setShowUpgradeResolution] = useState(false);
  const [showMyDesign, setShowMyDesign] = useState(false);
  const [showProfessional, setShowProfessional] = useState(true);
  const [showRemoveBG, setShowRemoveBG] = useState(false);
  const [imageUrlEditor, setImageUrlEditor] = useState('');
  const [isActiveMobileMenu, setIsActiveMobileMenu] = useState(false);
  const [isActiveDeskMenu, setIsActiveDeskMenu] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [showReferal, setShowReferal] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('');
  const [currentAge, setCurrentAge] = useState('');
  const [convertPose, setConvertPose] = useState(false);
  const [promptStyle, setPromptStyle] = useState('');
  const [promptBackground, setPromptBackground] = useState('');
  const [credits, setCredits] = useState(0);
  const [progress, setProgress] = useState(0);
  const navPopupRef = useRef(null);
  const [darkMode, setDarkMode] = useState(true);
  const [showEditor, setShowEditor] = useState(false);
  const [isAIVirtual, setIsAIVirtual] = useState(false);
  const [model, setModel] = useState('');
  const [creativity, setCreativity] = useState(6);

  const [roomsList, setRoomsList] = useState([]);
  const [interiorsList, setInteriorsList] = useState([]);
  const [exteriorsList, setExteriorsList] = useState([]);
  const [gardensList, setGardensList] = useState([]);
  const [promptErrorMessage, setPromptErrorMessage] = useState('');

  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [isSubmittedFeedback, setIsSubmittedFeedback] = useState(false);

  const [updateSettings] = useStore(state => [state.updateSettings]);

  const { t } = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  const photographerInfo = [
    {
      code: photographerStyle,
      name: t('photographers.sam.name'),
      title: t('photographers.sam.title'),
      imageUrl: '/images/sam.webp',
      introUrl: '/images/sam-intro.webp',
      intro: t('photographers.sam.intro'),
      intro1: t('photographers.sam.intro1'),
      intro2: t('photographers.sam.intro2'),
      intro3: t('photographers.sam.intro3'),
      intro4: t('photographers.sam.intro4'),
      intro5: t('photographers.sam.intro5'),
    },
    {
      code: photographerPose,
      name: t('photographers.david.name'),
      title: t('photographers.david.title'),
      imageUrl: '/images/david.webp',
      introUrl: '/images/david-intro.webp',
      intro: t('photographers.david.intro'),
      intro1: t('photographers.david.intro1'),
      intro2: t('photographers.david.intro2'),
      intro3: t('photographers.david.intro3'),
      intro4: t('photographers.david.intro4'),
      intro5: t('photographers.david.intro5'),
    },
    {
      code: photographerRemodeling,
      name: t('photographers.annie.name'),
      title: t('photographers.annie.title'),
      imageUrl: '/images/annie.webp',
      introUrl: '',
      beforeUrl: 'https://firebasestorage.googleapis.com/v0/b/airoomdecor.appspot.com/o/designers%2Finput-da810b2a-1ca0-42b8-a920-4ae750f167ff-2024-07-30-23-04-03_optimize.webp?alt=media&token=adc9a661-4683-4800-b62f-978a22f0e5fe',
      afterUrl: 'https://firebasestorage.googleapis.com/v0/b/airoomdecor.appspot.com/o/designers%2Fdecorify-input-0b13da78-9c83-4608-9a8f-f86e716b3d45.webp?alt=media&token=9162d112-fcdc-41d2-8d0b-a9109298410e',
      intro: t('photographers.annie.intro'),
      intro1: t('photographers.annie.intro1'),
      intro2: t('photographers.annie.intro2'),
      intro3: t('photographers.annie.intro3'),
      intro4: t('photographers.annie.intro4'),
      intro5: t('photographers.annie.intro5'),
    },
  ];

  useEffect(() => {
    setCurrentLanguage(i18n.language);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // Access specific parameters
    const imageUrl = params.url;

    if (imageUrl !== undefined && imageUrl !== '') {
      sampleUploadFromLink(imageUrl);
    }
  }, [i18n.language]);

  useEffect(() => {
    // setIsSpinning(true);
    // setCurrentJob(null);
    const unsubscribe = firebase.auth.onAuthStateChanged(user => {
      if (user) {
        // User is authenticated, fetch the user data
        firebase
          .getUser(user.uid)
          .then(querySnapshot => {
            if (!querySnapshot.empty) {
              setUserData(querySnapshot.data());
              const credits = querySnapshot.data().proCredits;
              updateSettings({ credits: credits });

              // setIsSpinning(false);
              setTimeout(() => {
                setIsSpinning(false);
                // checkNewUsersCredits(querySnapshot.data().proCredits);
                // window.HubSpotConversations.widget.remove();
              }, 2000);

              firebase
                .getRooms()
                .then(result => {
                  const roomsArr = result.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                  }));

                  roomsArr.sort((a, b) => a.priority - b.priority);

                  const interiors = roomsArr.filter(room => room.type === 'interior').sort((a, b) => a.priority - b.priority);

                  const exteriors = roomsArr.filter(room => room.type === 'exterior').sort((a, b) => a.priority - b.priority);

                  const gardens = roomsArr.filter(room => room.type === 'garden').sort((a, b) => a.priority - b.priority);

                  setRoomsList(roomsArr);
                  setInteriorsList(interiors);
                  setExteriorsList(exteriors);
                  setGardensList(gardens);
                })
                .catch(error => {
                  console.log(error);
                });

              firebase
                .getThemes()
                .then(result => {
                  const styleArr = result.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                  }));

                  styleArr.sort((a, b) => a.priority - b.priority);

                  setStyles(styleArr);
                })
                .catch(error => {
                  console.log(error);
                });
            }
          })
          .catch(error => {
            console.log(error);
            setIsSpinning(false);
          });
      } else {
        // User is not authenticated, clear the user data
        setUserData(null);
        setUser(null);
        setIsSpinning(false);
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 980) {
      setIsMobile(true);
      setIsActiveDeskMenu(false);
    }

    const handleResize = () => {
      if (window.innerWidth <= 980) {
        setIsMobile(true);
        setIsActiveDeskMenu(false);
      } else {
        setIsMobile(false);
        setIsActiveDeskMenu(true);
      }
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // Add event listener to close the popup when clicked outside
    const handleClickOutside = event => {
      if (navPopupRef.current && event.target.contains(navPopupRef.current)) {
        setIsActiveMobileMenu(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [navPopupRef]);

  function checkCredits() {
    if (mode === modes.pro && ((userData.pro && userData.proCredits < 2) || !userData.pro)) {
      message.warning(t('message.warning.runOutProCredits'));
      setTimeout(() => {
        setIsCreating(false);
        onShowPricing(true);
        setShowGenFillEditor(false);
      }, 1500);
      return true;
    }

    if (mode === modes.basic && ((userData.basic && userData.basicCredits < 2) || !userData.basic)) {
      message.warning(t('message.warning.runOutBasicCredits'));
      setTimeout(() => {
        setIsCreating(false);
        onShowPricing(true);
        setShowGenFillEditor(false);
      }, 1500);
      return true;
    }

    return false;
  }

  function checkNewUsersCredits(cre) {
    if (cre < 2) {
      message.warning(t('message.warning.runOutProCredits'));
      setTimeout(() => {
        setIsCreating(false);
        onShowPricing(true);
        setShowGenFillEditor(false);
      }, 1500);
      return true;
    }

    return false;
  }

  function checkCreditsProfessional() {
    if (mode === modes.pro && userData.pro && userData.proCredits < currentResult * 5) {
      message.warning(t('message.warning.runOutProCredits'));
      setTimeout(() => {
        setIsCreating(false);
        onShowPricing(true);
        setShowGenFillEditor(false);
      }, 1500);
      return true;
    }
    return false;
  }

  const onCloseImageEdit = () => {
    setShowGenFillEditor(false);
  };

  const scrollToMyResult = () => {
    const section = document.querySelector('#my-result');
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const scrollToTop = () => {
    const section = document.querySelector('#scroll-top');
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const incrementProgress = () => {
    setProgress(prevProgress => {
      const newProgress = prevProgress + Math.floor(Math.random() * 5) + 1;

      if (newProgress < 90) {
        return newProgress;
      } else {
        return prevProgress; // Return the previous state without updating
      }
    });
  };

  function onDesignProfessional() {
    if (!!promptErrorMessage) {
      message.error(t('message.error.badWordsStyle'));
      return;
    }

    if (checkCreditsProfessional()) return;

    if (photographerCode === '' || photographerSrc === '') {
      message.error(t('message.error.selectPhotographer'));
      setTimeout(() => {
        setIsShowPhotographer(true);
      }, 2000);
      return;
    }

    if (!fileInfo) {
      message.error(t('message.error.uploadPhoto'));
      return;
    }

    if (!currentRoomType) {
      message.error(t('message.error.roomType'));
      return;
    }

    if ((!styleCode || styleCode === '') && promptStyle === '') {
      message.error(t('message.error.style'));
      return;
    }

    if (!currentResult || currentResult === '') {
      message.error(t('message.error.numberOfResult'));
      return;
    }

    //maintain
    // alert(t('message.maintain.backsoon'));
    // return;

    setIsCreating(true);

    const fileSize = file.size;
    const maxSizeBasic = 10 * 1024 * 1024;
    const maxSizePro = 10 * 1024 * 1024;

    if (mode === modes.pro && fileSize > maxSizePro) {
      message.error(t('message.error.fileOverPro'));
      setIsCreating(false);
      return;
    }
    if (mode === modes.basic && fileSize > maxSizeBasic) {
      message.error(t('message.error.fileOverPro'));
      setIsCreating(false);
      return;
    }

    firebase
      .uploadFile(file)
      .then(async downloadURL => {
        const imageUrl = downloadURL;

        if (!imageUrl) return;

        let prompt = t(`styles.${styleCode}`) + ' - ' + t(`roomsList.${currentRoomType}`);
        let isCustomedStyle = false;
        let style = styleCode;
        let room = currentRoomType;

        if (promptStyle !== '') {
          // custom only style
          prompt = promptStyle;
          isCustomedStyle = true;
        }

        const resultItem = results.find(item => item.value === currentResult);
        const job = {
          images: {
            before: imageUrl,
            after: '',
          },
          status: 'starting',
          progress: 0,
          prompt: prompt,
          result: t(`results.${resultItem.label}`),
        };

        setCurrentJob(job);

        message.success(t('message.success.redering'));

        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${firebase.auth.currentUser.accessToken}`,
        };

        let requestDataEng = {
          imageUrl: imageUrl,
          packageName: mode,
          quantity: currentResult,
          prompt: prompt,
          style: style,
          room: room,
          isCustomedStyle: isCustomedStyle,
          photographer: photographerCode,
          creativity: creativity,
        };

        const result = await axios.post(`${APP_URL_V4}/render`, requestDataEng, { headers });

        const jobIds = result.data.ids;
        const credits = result.data.credits;
        updateSettings({ credits: credits });

        for (let index = 0; index < jobIds.length; index++) {
          const jobId = jobIds[index];

          while (true) {
            const result = await axios.get(`${APP_URL_V3}/job/${jobId}`, {}, { headers });

            if (result.data.status === 'finished') {
              setProgress(100);

              setTimeout(() => {
                // Result is finished, you can access it using result.data.output or perform further actions
                let finishedImage = result.data.image;

                const newImages = {
                  before: imageUrl,
                  after: finishedImage,
                };

                // Add new job to AllShowCase
                const newJob = {
                  images: newImages,
                  status: 'finished',
                  prompt: prompt,
                  uid: userData.uid,
                  id: result.data.id,
                  isLoved: false,
                };
                setCurrentJob(newJob);

                firebase
                  .getUser(firebase.auth.currentUser.uid)
                  .then(querySnapshot => {
                    setUser(querySnapshot.data());
                    setUserData(querySnapshot.data());
                  })
                  .catch(err => {
                    message.error(err.message);
                  });
              }, 1000);

              break;
            } else if (result.data.status === 'nsfw') {
              // Result is finished, you can access it using result.data.output or perform further actions
              let finishedImage = result.data.image;

              const newImages = {
                before: imageUrl,
                after: finishedImage,
              };

              const newJob = {
                images: newImages,
                prompt: prompt,
                uid: userData.uid,
                id: result.data.id,
                isLoved: false,
                status: 'nsfw',
              };
              setCurrentJob(newJob);

              firebase
                .getUser(firebase.auth.currentUser.uid)
                .then(querySnapshot => {
                  setUser(querySnapshot.data());
                  setUserData(querySnapshot.data());
                })
                .catch(err => {
                  message.error(err.message);
                });
              break;
            } else if (result.data.status === 'failed-face') {
              // Job failed, handle the failure case
              message.error(t('message.error.wrongFace'));
              const job = {
                status: 'failed-face',
              };

              setCurrentJob(job);
              setIsCreating(false);
              return;
            } else if (result.data.status === 'failed') {
              // Job failed, handle the failure case
              message.error(t('message.error.wrongFace'));
              setIsCreating(false);
              return;
            } else {
              if (result.data.status > progress) {
                setProgress(result.data.status);
              } else {
                incrementProgress();
              }
            }
            // If the job is not yet finished, wait for some time before making the next request
            await new Promise(resolve => setTimeout(resolve, 3000));
          }
        }

        // confetti({
        //   origin: { y: 0.5 },
        //   spread: 400,
        //   particleCount: 100,
        //   origin: { y: 0.4 },
        // });
        message.success(t('message.success.rederingDone'));
        setIsCreating(false);
        setProgress(0);
      })
      .catch(error => {
        if (error.response.data.error === 'not-enough-credits') {
          message.error(t('message.error.outOfCredits'));
          setIsCreating(false);
          return;
        }
        message.error(t('message.error.wrongFace'));
        setIsCreating(false);
        // Handle the error
      });
  }

  function onGenFill(newJob) {
    setCurrentJob(newJob);
  }

  function onChangeImageSrc(imageUrl) {
    setImageUrlEditor(imageUrl);
  }

  function handleModeChangeParent(mode) {
    setMode(mode);
  }

  function handleChangeRoomType(event) {
    setCurrentRoomType(event.target.value);
  }

  function handleCurrentPoses(gender) {
    const filteredPoses = posesList.filter(pose => pose.gender === gender);
    setCurrentPoses(filteredPoses);
  }

  function handleSelectPose(pose, isConvertPose) {
    // setCurrentPoseId(pose.poseUrl);
    setIsShowPose(false);
    setPoseSrc(pose.imageUrl);
    setConvertPose(isConvertPose);

    if (isConvertPose) {
      setPoseUrl(pose.imageUrl);
    } else {
      setPoseUrl(pose.poseUrl);
    }
  }

  function handleSelectBackground(background) {
    setIsShowBackground(false);
    setBackgroundSrc(background.imageUrl);
    setBackgroundName(background.name);
    setBackgroundCode(background.code);
    setPromptBackground('');
  }

  function handleSelectStyle(style) {
    setIsShowStyle(false);
    setStyleSrc(style.url);
    // setStyleName(style.name);
    setStyleCode(style.code);
    setPromptStyle('');
  }

  function handleSelectPhotographer(photographer) {
    setIsShowPhotographer(false);
    setPhotographerSrc(photographer.imageUrl);
    setPhotographerName(photographer.name + ' ' + photographer.title);
    setPhotographerCode(photographer.code);

    if (photographer.code !== photographerRemodeling) {
      setCurrentResult(4);
      setCredits(20);
      if (photographer.code === photographerPose) {
        setCreativity(8);
      }
    } else {
      setCurrentResult(1);
      setCredits(5);
    }
  }

  function handleChangeResult(event) {
    setCurrentResult(event.target.value);
    if (event.target.value === 1) {
      setCredits(5);
    }
    if (event.target.value === 4) {
      setCredits(20);
    }
  }

  function onShowPricing(value) {
    setIsShowPricing(value);
  }

  function onShowPose(value) {
    setIsShowPose(value);
  }

  function onShowBackground(value) {
    setIsShowBackground(value);
  }

  function onShowStyle(value) {
    setIsShowStyle(value);
  }

  function onShowPhotographer(value) {
    setIsShowPhotographer(value);
  }

  function onShowReferal() {
    setShowReferal(true);
    setShowUpgradeResolution(false);
    setShowMyDesign(false);
    setShowEditor(false);
    setShowProfessional(false);
    setShowRemoveBG(false);

    const activeLink = document.querySelector('.nav-link.active');
    activeLink.classList.remove('active');
    setIsActiveMobileMenu(false);
  }

  function onFetchUser() {
    firebase
      .getUser(firebase.auth.currentUser.uid)
      .then(querySnapshot => {
        if (!querySnapshot.empty) {
          setUserData(querySnapshot.data());
          setUser(querySnapshot.data());
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function onFetchUser() {
    firebase
      .getUser(firebase.auth.currentUser.uid)
      .then(querySnapshot => {
        if (!querySnapshot.empty) {
          setUserData(querySnapshot.data());
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  const checkFileSize = file => {
    const fileSize = file.size;
    const maxSizeBasic = 10 * 1024 * 1024;
    const maxSizePro = 10 * 1024 * 1024;

    if (mode === modes.pro && fileSize > maxSizePro) {
      message.error(t('message.error.fileOverPro'));
      setIsCreating(false);
      return false;
    }
    if (mode === modes.basic && fileSize > maxSizeBasic) {
      message.error(t('message.error.fileOverPro'));
      setIsCreating(false);
      return false;
    }
    return true;
  };

  const handleFileUpload = event => {
    const file = event.target.files[0];

    if (checkFileSize(file) === false) return;

    setFile(file);
    const reader = new FileReader();

    reader.onload = function () {
      const image = new Image();

      image.onload = function () {
        const canvas = document.createElement('canvas');
        const scaleSize = MAX_WIDTH / image.width;
        canvas.width = image.width;
        canvas.height = image.height;

        const ctx = canvas.getContext('2d');

        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        if (file.name === '' || file.name === undefined) {
          file.name = `decorify-input-${uuidv4()}.jpg`;
        }

        canvas.toBlob(blob => {
          const canvasImage = new File([blob], file.name, {
            type: file.type,
            lastModified: file.lastModified,
          });
          setFileInfo(canvasImage); // Set fileInfo as the canvas image with additional properties
          setFile(canvasImage);

          const reader2 = new FileReader();
          reader2.onloadend = function () {
            const srcEncoded = reader2.result;
            setImageSrc(srcEncoded);
          };

          canvas.remove(); // Remove the canvas element
          reader2.readAsDataURL(blob);
        }, 'image/jpeg');
      };

      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  const handleFileUploadFromLink = async (event, imageUrl) => {
    scrollToTop();
    onActiveUpgradeResolution(event);
    const response = await fetch(imageUrl);
    const file = await response.blob();

    if (checkFileSize(file) === false) return;

    setFile(file);
    const reader = new FileReader();

    reader.onload = function () {
      const image = new Image();

      image.onload = function () {
        const canvas = document.createElement('canvas');
        const scaleSize = MAX_WIDTH / image.width;
        canvas.width = MAX_WIDTH;
        canvas.height = image.height * scaleSize;

        const ctx = canvas.getContext('2d');

        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        if (file.name === '' || file.name === undefined) {
          file.name = `decorify-input-${uuidv4()}.jpg`;
        }

        canvas.toBlob(blob => {
          const canvasImage = new File([blob], file.name, {
            type: file.type,
            lastModified: file.lastModified,
          });
          setFileInfo(canvasImage); // Set fileInfo as the canvas image with additional properties
          setFile(canvasImage);

          const reader2 = new FileReader();
          reader2.onloadend = function () {
            const srcEncoded = reader2.result;
            setImageSrc(srcEncoded);
          };

          canvas.remove(); // Remove the canvas element
          reader2.readAsDataURL(blob);
        }, 'image/jpeg');
      };

      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  const handleOnUpImageResolution = async (event, imageUrl) => {
    onActiveUpgradeTo4K(event);

    const activeLink = document.querySelector('#upscale-4k');
    if (activeLink) {
      activeLink.classList.add('active');
    }

    // setIsActiveMobileMenu(false);

    const response = await fetch(imageUrl);
    const blob = await response.blob();
    if (checkFileSize(blob) === false) return;

    // const decodedUrl = decodeURIComponent(imageUrl);
    // const fileName = decodedUrl.split('/').pop().split('?')[0];

    // const file = new File([blob], fileName, {
    //     type: blob.type
    // });

    setFile(blob);
  };

  const sampleUploadFromLink = async imageUrl => {
    const response = await fetch(imageUrl);
    const file = await response.blob();

    if (checkFileSize(file) === false) return;

    setFile(file);
    const reader = new FileReader();

    reader.onload = function () {
      const image = new Image();

      image.onload = function () {
        const canvas = document.createElement('canvas');
        const scaleSize = MAX_WIDTH / image.width;
        canvas.width = MAX_WIDTH;
        canvas.height = image.height * scaleSize;

        const ctx = canvas.getContext('2d');

        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        if (file.name === '' || file.name === undefined) {
          file.name = `decorify-input-${uuidv4()}.jpg`;
        }

        canvas.toBlob(blob => {
          const canvasImage = new File([blob], file.name, {
            type: file.type,
            lastModified: file.lastModified,
          });
          setFileInfo(canvasImage); // Set fileInfo as the canvas image with additional properties
          setFile(canvasImage);

          const reader2 = new FileReader();
          reader2.onloadend = function () {
            const srcEncoded = reader2.result;
            setImageSrc(srcEncoded);
          };

          canvas.remove(); // Remove the canvas element
          reader2.readAsDataURL(blob);
        }, 'image/jpeg');
      };

      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  };

  const handleOpenFileUpload = () => {
    fileInputRef.current.click();
  };

  const handleOpenPoseUpload = () => {
    if (currentRoomType === '') {
      message.warning(t('message.warning.selectPose'));
      return;
    }
    setIsShowPose(true);
  };

  const handleSetPoseFile = function (file, convertPose) {
    setPoseSrc(file); //Show on UI
    setPoseUrl(file); // Send to backend with converted pose
    setConvertPose(convertPose);

    firebase
      .getUploadedPoses(userData.uid)
      .then(result => {
        const uploadedPosesArr = result.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        setUploadedPosesList(uploadedPosesArr);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const handleBackgroundUpload = () => {
    setIsShowBackground(true);
  };

  const handleStyleUpload = () => {
    setIsShowStyle(true);
  };

  const handlePhotographer = () => {
    setIsShowPhotographer(true);
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];

      if (checkFileSize(file) === false) return;

      setFile(file);
      const reader = new FileReader();

      reader.onload = function () {
        const image = new Image();

        image.onload = function () {
          const canvas = document.createElement('canvas');
          const scaleSize = MAX_WIDTH / image.width;
          // canvas.width = MAX_WIDTH;
          // canvas.height = image.height * scaleSize;

          canvas.width = image.width;
          canvas.height = image.height;

          const ctx = canvas.getContext('2d');

          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

          if (file.name === '' || file.name === undefined) {
            file.name = `decorify-input-${uuidv4()}.jpg`;
          }

          canvas.toBlob(blob => {
            const canvasImage = new File([blob], file.name, {
              type: file.type,
              lastModified: file.lastModified,
            });
            setFileInfo(canvasImage); // Set fileInfo as the canvas image with additional properties
            setFile(canvasImage);

            const reader2 = new FileReader();
            reader2.onloadend = function () {
              const srcEncoded = reader2.result;
              setImageSrc(srcEncoded);
            };

            canvas.remove(); // Remove the canvas element
            reader2.readAsDataURL(blob);
          }, 'image/jpeg');
        };

        image.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  };

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === 'dragenter' || e.type === 'dragover') {
      const uploaderWrapper = document.querySelector('.uploader-wrapper');
      uploaderWrapper.style.border = '1px dashed rgb(255 204 2)';
      uploaderWrapper.style.color = 'rgb(255 204 2)';
    } else if (e.type === 'dragleave') {
      const uploaderWrapper = document.querySelector('.uploader-wrapper');
      uploaderWrapper.style.border = '1px dashed rgb(0 0 0 / 20%)';
      uploaderWrapper.style.color = '#8c8c8c';
    }
  };

  const handleOnRemoveBG = async (event, imageUrl) => {
    // scrollToTop();
    onActiveRemoveObject(event);

    const activeLink = document.querySelector('#remove-object');
    if (activeLink) {
      activeLink.classList.add('active');
    }

    setIsActiveMobileMenu(false);

    const response = await fetch(imageUrl);
    const blob = await response.blob();
    if (checkFileSize(blob) === false) return;

    // const decodedUrl = decodeURIComponent(imageUrl);
    // const fileName = decodedUrl.split('/').pop().split('?')[0];

    // const file = new File([blob], fileName, {
    //     type: blob.type
    // });

    setFile(blob);
  };

  const removeUploadedImage = function (e) {
    e.preventDefault();
    setFileInfo(null);
    setImageSrc('');
  };

  const onVirtualHome = async (event, imageUrl) => {
    // scrollToTop();
    onActiveAIVirtualHome(event);

    const activeLink = document.querySelector('#virtual-home');
    if (activeLink) {
      activeLink.classList.add('active');
    }

    setIsActiveMobileMenu(false);

    const response = await fetch(imageUrl);
    const blob = await response.blob();
    if (checkFileSize(blob) === false) return;

    // const decodedUrl = decodeURIComponent(imageUrl);
    // const fileName = decodedUrl.split('/').pop().split('?')[0];

    // const file = new File([blob], fileName, {
    //     type: blob.type
    // });

    setFile(blob);
  };

  const removeUploadedPose = function (e) {
    e.preventDefault();
    // setFileInfo(null);
    setPoseSrc('');
    setPoseUrl('');
    setConvertPose(true);
  };

  const removeUploadedBackground = function (e) {
    setBackgroundSrc('');
    setBackgroundName('');
  };

  const removeUploadedStyle = function (e) {
    setStyleSrc('');
    setStyleName('');
    setStyleCode('');
    // setPromptStyle('');
  };

  const removePhotographer = function (e) {
    setPhotographerSrc('');
    setPhotographerName('');
    setPhotographerCode('');
    setCredits(0);
    setCurrentResult(0);
  };

  function onActiveRemoveBG(event) {
    setShowRemoveBG(true);
    setShowProfessional(false);
    setShowUpgradeResolution(false);
    setShowMyDesign(false);
    setShowEditor(false);
    setShowReferal(false);

    const activeLink = document.querySelector('.nav-link.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    event.currentTarget.classList.add('active');
    setIsActiveMobileMenu(false);
  }

  function onActiveProfessional(event) {
    setShowProfessional(true);
    setShowRemoveBG(false);
    setShowUpgradeResolution(false);
    setShowMyDesign(false);
    setShowEditor(false);
    setShowReferal(false);
    setCurrentJob(null);

    const activeLink = document.querySelector('.nav-link.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    event.currentTarget.classList.add('active');
    setIsActiveMobileMenu(false);
  }

  function onActiveUpgradeResolution(event) {
    setShowUpgradeResolution(true);
    setShowRemoveBG(false);
    setShowProfessional(false);
    setShowMyDesign(false);
    setShowEditor(false);
    setShowReferal(false);

    const activeLink = document.querySelector('.nav-link.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    event.currentTarget.classList.add('active');
    setIsActiveMobileMenu(false);
  }

  function onActiveMyPhoto(event) {
    setShowMyDesign(true);
    setShowEditor(false);
    setShowRemoveBG(false);
    setShowProfessional(false);
    setShowUpgradeResolution(false);
    setShowReferal(false);

    const activeLink = document.querySelector('.nav-link.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    event.currentTarget.classList.add('active');
    setIsActiveMobileMenu(false);
  }

  function onActiveRemoveObject(event) {
    setShowEditor(true);
    setModel(REMOVE_OBJECTS_MODEL);
    setIsAIVirtual(false);
    setShowMyDesign(false);
    setShowRemoveBG(false);
    setShowProfessional(false);
    setShowUpgradeResolution(false);
    setShowReferal(false);

    const activeLink = document.querySelector('.nav-link.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    event.currentTarget.classList.add('active');
    setIsActiveMobileMenu(false);
  }

  function onActiveUpgradeTo4K(event) {
    setShowUpgradeResolution(true);
    setShowEditor(true);
    setModel(UPSCALE_MODEL);
    setShowRemoveBG(false);
    setShowProfessional(false);
    setShowMyDesign(false);
    setShowReferal(false);

    const activeLink = document.querySelector('.nav-link.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    event.currentTarget.classList.add('active');
    setIsActiveMobileMenu(false);
  }

  function onActiveAIVirtualHome(event) {
    setShowEditor(true);
    setModel(VIRTUAL_STAGING_MODEL);
    setIsAIVirtual(true);
    setShowMyDesign(false);
    setShowRemoveBG(false);
    setShowProfessional(false);
    setShowUpgradeResolution(false);
    setShowReferal(false);

    const activeLink = document.querySelector('.nav-link.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    event.currentTarget.classList.add('active');
    setIsActiveMobileMenu(false);
  }

  const openMobileMenu = () => {
    setIsActiveMobileMenu(!isActiveMobileMenu);
  };

  function chooseSampleProfessional(event, link, gender) {
    event.preventDefault();

    sampleUploadFromLink(link);
  }

  function chooseBadSampleProfessional(event, link, gender) {
    event.preventDefault();

    sampleUploadFromLink(link);
    // setCurrentResult('');
    setCurrentRoomType('');
    setCurrentStyle('');
  }

  const handleChangeAge = event => {
    setCurrentAge(event.target.value);
  };

  const submitPromptStyle = prompt => {
    setPromptStyle(prompt);
    onShowStyle(false);
  };

  const submitPromptBG = prompt => {
    setPromptBackground(prompt);
    onShowBackground(false);
  };

  const hideMenuBar = () => {
    setIsActiveDeskMenu(!isActiveDeskMenu);
  };

  function onActiveOnlyProfessional() {
    setShowProfessional(true);
    setShowRemoveBG(false);
    setShowUpgradeResolution(false);
    setShowMyDesign(false);
    setShowEditor(false);
    setShowReferal(false);

    const activeLink = document.querySelector('.nav-link.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }

    const firstNavLink = document.querySelector('.nav-link');
    if (firstNavLink) {
      firstNavLink.classList.add('active');
    }

    // event.currentTarget.classList.add('active');
    setIsActiveMobileMenu(false);
  }

  const handleSelectCollection = collection => {
    setPhotographerSrc('');
    setPhotographerName('');
    setPhotographerCode('');
    message.success(t('message.success.useTheTemplate'));

    setTimeout(() => {
      // Set photographer
      onActiveOnlyProfessional();
      setPhotographerCode(collection.photographerCode);
      setPhotographerName(collection.photographerName + ', ' + collection.title);
      setPhotographerSrc(collection.photographerUrl);

      setCurrentRoomType(collection.roomType);
      setPromptStyle(collection.style);
      setStyleName(collection.name);
      setStyleSrc(collection.imageUrl);
      setStyleCode(collection.styleCode);

      setPromptBackground(collection.background);
      setBackgroundName(collection.background);
      setBackgroundSrc('/images/custom-style.webp');
      onShowBackground(false);

      // Default
      if (collection.photographerCode !== photographerRemodeling) {
        setCurrentResult(4);
        setCredits(20);
      } else {
        setCurrentResult(1);
        setCredits(5);
      }
      scrollToTop();
    }, 500);
  };

  const onSelectDarkMode = () => {
    setDarkMode(!darkMode);

    const htmlElement = document.documentElement;

    if (!darkMode) {
      // If dark mode is enabled, set the background to black
      htmlElement.style.background = '#000';
    } else {
      // If dark mode is disabled, remove the background style
      htmlElement.style.removeProperty('background');
    }
  };

  const handleInputChange = event => {
    const newValue = event.target.value;
    debouncedValidation(newValue);

    setPromptStyle(newValue);
  };

  const debouncedValidation = debounce((value) => {
    const badWord = containsBadWord(value);
    if (badWord) {
      setPromptErrorMessage(t('message.error.badWordsStyle', { word: badWord }));
    } else {
      setPromptErrorMessage('');
    }
  }, 100);

  const handleSubmittedFeedback = (submitted) => {
    setIsSubmittedFeedback(submitted);
  };

  const onShowFeedback = () => {
    setShowFeedbackModal(true);
  };

  const renderStrength = () => {
    return (
      <div className="flex flex-col gap-1">
        <RowContainer>
          <Slider
            className="w-full"
            defaultValue={[8]}
            min={1}
            max={10}
            step={1}
            value={[creativity]}
            onValueChange={vals => setCreativity(vals[0])}
          />
          <label className={`${darkMode ? 'text-white' : 'text-black'}`} style={{ marginLeft: '10px' }}>
            {creativity}
          </label>
        </RowContainer>
      </div>
    );
  };

  return (
    <div>
      {userData && (
        <div>
          {!isMobile ? (
            <div className="left-area" style={!isActiveDeskMenu ? { left: '-350px' } : { left: '0' }} id="scroll-top-nav">
              <div className="logo-header-desk">
                <HeaderSticky
                  currentLanguage={currentLanguage}
                  isMobile={isMobile}
                  isActiveMobileMenu={isActiveMobileMenu}
                  openMobileMenu={openMobileMenu}
                  onActiveProfessional={onActiveProfessional}
                />
              </div>
              <>
                <div className="sub-area">
                  <ComposeSection
                    t={t}
                    userData={userData}
                    handleModeChangeParent={handleModeChangeParent}
                    onShowPricing={onShowPricing}
                    defaultMode={mode}
                    onShowReferal={onShowReferal}
                    currentLanguage={currentLanguage}
                    firebase={firebase}
                    onFetchUser={onFetchUser}
                  />
                </div>
                <div className="nav-wrapper">
                  <div className="nav-menu">
                    <Link
                      to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}
                      className="nav-link active"
                      onClick={onActiveProfessional}
                    >
                      <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.6139 1.21065C12.2528 0.929784 11.7472 0.929784 11.3861 1.21065L2.38606 8.21065C2.14247 8.4001 2 8.69141 2 9V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V9C22 8.69141 21.8575 8.4001 21.6139 8.21065L12.6139 1.21065ZM16 20H20V9.48908L12 3.26686L4 9.48908V20H8V12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12V20ZM10 20V13H14V20H10Z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>{t('app.menu.professionalMode')}</span>
                    </Link>
                    <Link
                      to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}
                      id="virtual-home"
                      className="nav-link"
                      onClick={onActiveAIVirtualHome}
                    >
                      <Sparkles />
                      <span>{t('app.menu.aiVirtualStaging')}</span>
                    </Link>
                    <Link
                      to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}
                      id="remove-object"
                      className="nav-link"
                      onClick={onActiveRemoveObject}
                    >
                      <Eraser />
                      <span>{t('app.menu.removeBGMode')}</span>
                    </Link>
                    <Link
                      to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}
                      id="upscale-4k"
                      className="nav-link"
                      onClick={onActiveUpgradeTo4K}
                    >
                      <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        className="bi bi-badge-4k"
                      >
                        <path d="M4.807 5.001C4.021 6.298 3.203 7.6 2.5 8.917v.971h2.905V11h1.112V9.888h.733V8.93h-.733V5.001h-1.71zm-1.23 3.93v-.032a46.781 46.781 0 0 1 1.766-3.001h.062V8.93H3.577zm9.831-3.93h-1.306L9.835 7.687h-.057V5H8.59v6h1.187V9.075l.615-.699L12.072 11H13.5l-2.232-3.415 2.14-2.584z" />
                        <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z" />
                      </svg>
                      <span>{t('app.menu.unBluryMode')}</span>
                    </Link>
                    <Link to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`} className="nav-link" onClick={onActiveMyPhoto}>
                      <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3,11h7a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3v7A1,1,0,0,0,3,11ZM4,4H9V9H4ZM22,3a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1ZM20,9H15V4h5ZM2,21a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H3a1,1,0,0,0-1,1Zm2-6H9v5H4Zm18,6V14a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7A1,1,0,0,0,22,21Zm-2-1H15V15h5Z" />
                      </svg>
                      <span>{t('app.menu.myPhotos')}</span>
                    </Link>
                  </div>
                </div>
                <div className="left-down-menu">
                  {currentLanguage === 'vi' ? (
                    <div className="idea-alert" onClick={() => onShowReferal(true)}>
                      <div className="idea-inner">
                        <div className="ref-title">
                          <svg stroke="#ef4444" fill="#ef4444" strokeWidth="0" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                            <path d="M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" />
                          </svg>
                          <span>{t('app.menu.affiliateTitle')}</span>
                        </div>
                        <div className="ref-des">{t('app.menu.affiliateSub')}</div>
                      </div>
                    </div>
                  ) : (
                    <div className="idea-alert">
                      <a href="https://decorify.lemonsqueezy.com/affiliates">
                        <div className="idea-inner">
                          <div className="ref-title">
                            <svg stroke="#ef4444" fill="#ef4444" strokeWidth="0" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                              <path d="M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" />
                            </svg>
                            <span>{t('app.menu.affiliateTitle')}</span>
                          </div>
                          <div className="ref-des">{t('app.menu.affiliateSub')}</div>
                        </div>
                      </a>
                    </div>
                  )}
                  <div className="dropdown">
                    <NewAvatarHeader userData={userData} t={t} darkMode={darkMode} onSelectDarkMode={onSelectDarkMode} onShowFeedback={onShowFeedback}
                    />
                  </div>
                </div>
              </>
            </div>
          ) : (
            <div>
              <div className="logo-header">
                <HeaderSticky
                  currentLanguage={currentLanguage}
                  isMobile={isMobile}
                  isActiveMobileMenu={isActiveMobileMenu}
                  openMobileMenu={openMobileMenu}
                  onActiveProfessional={onActiveProfessional}
                />
              </div>
              <div
                className={
                  isActiveMobileMenu
                    ? 'left-area-wrap inset-0 z-50 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0'
                    : ''
                }
              >
                <div className="left-area" style={isActiveMobileMenu ? { left: '0' } : {}} ref={navPopupRef}>
                  <div className="sub-area">
                    <ComposeSection
                      t={t}
                      userData={userData}
                      handleModeChangeParent={handleModeChangeParent}
                      onShowPricing={onShowPricing}
                      defaultMode={mode}
                      onShowReferal={onShowReferal}
                      currentLanguage={currentLanguage}
                      firebase={firebase}
                      onFetchUser={onFetchUser}
                    />
                  </div>
                  <div className="nav-menu">
                    <Link
                      to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}
                      className="nav-link active"
                      onClick={onActiveProfessional}
                    >
                      <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.6139 1.21065C12.2528 0.929784 11.7472 0.929784 11.3861 1.21065L2.38606 8.21065C2.14247 8.4001 2 8.69141 2 9V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V9C22 8.69141 21.8575 8.4001 21.6139 8.21065L12.6139 1.21065ZM16 20H20V9.48908L12 3.26686L4 9.48908V20H8V12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12V20ZM10 20V13H14V20H10Z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>{t('app.menu.professionalMode')}</span>
                    </Link>
                    <Link
                      to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}
                      id="virtual-home"
                      className="nav-link"
                      onClick={onActiveAIVirtualHome}
                    >
                      <Sparkles />
                      <span>{t('app.menu.aiVirtualStaging')}</span>
                    </Link>
                    <Link
                      to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}
                      id="remove-object"
                      className="nav-link"
                      onClick={onActiveRemoveObject}
                    >
                      <Eraser />
                      <span>{t('app.menu.removeBGMode')}</span>
                    </Link>
                    <Link
                      to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}
                      id="upscale-4k"
                      className="nav-link"
                      onClick={onActiveUpgradeTo4K}
                    >
                      <svg
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        className="bi bi-badge-4k"
                      >
                        <path d="M4.807 5.001C4.021 6.298 3.203 7.6 2.5 8.917v.971h2.905V11h1.112V9.888h.733V8.93h-.733V5.001h-1.71zm-1.23 3.93v-.032a46.781 46.781 0 0 1 1.766-3.001h.062V8.93H3.577zm9.831-3.93h-1.306L9.835 7.687h-.057V5H8.59v6h1.187V9.075l.615-.699L12.072 11H13.5l-2.232-3.415 2.14-2.584z" />
                        <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z" />
                      </svg>
                      <span>{t('app.menu.unBluryMode')}</span>
                    </Link>
                    <Link to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`} className="nav-link" onClick={onActiveMyPhoto}>
                      <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3,11h7a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3v7A1,1,0,0,0,3,11ZM4,4H9V9H4ZM22,3a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1ZM20,9H15V4h5ZM2,21a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H3a1,1,0,0,0-1,1Zm2-6H9v5H4Zm18,6V14a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7A1,1,0,0,0,22,21Zm-2-1H15V15h5Z" />
                      </svg>
                      <span>{t('app.menu.myPhotos')}</span>
                    </Link>
                  </div>
                  <div className="left-down-menu">
                    {currentLanguage === 'vi' ? (
                      <div className="idea-alert" onClick={() => onShowReferal(true)}>
                        <div className="idea-inner">
                          <div className="ref-title">
                            <svg stroke="#ef4444" fill="#ef4444" strokeWidth="0" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                              <path d="M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" />
                            </svg>
                            <span>{t('app.menu.affiliateTitle')}</span>
                          </div>
                          <div className="ref-des">{t('app.menu.affiliateSub')}</div>
                        </div>
                      </div>
                    ) : (
                      <div className="idea-alert">
                        <a href="https://decorify.lemonsqueezy.com/affiliates">
                          <div className="idea-inner">
                            <div className="ref-title">
                              <svg
                                stroke="#ef4444"
                                fill="#ef4444"
                                strokeWidth="0"
                                viewBox="0 0 1024 1024"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z" />
                              </svg>
                              <span>{t('app.menu.affiliateTitle')}</span>
                            </div>
                            <div className="ref-des">{t('app.menu.affiliateSub')}</div>
                          </div>
                        </a>
                      </div>
                    )}
                    <div className="dropdown">
                      <NewAvatarHeader userData={userData} t={t} darkMode={darkMode} onSelectDarkMode={onSelectDarkMode} onShowFeedback={onShowFeedback} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div id="scroll-top">
            {showProfessional && (
              <div
                className={`right-area editor-area ${darkMode ? 'dark-bg' : 'light-bg'}`}
                style={!isActiveDeskMenu ? { left: '0', width: '100%' } : { transition: 'width 0.35s ease', width: 'calc(100% - 250px)' }}
              >
                <div className={`form-area ${darkMode ? 'dark-bg dark-border-2' : 'light-bg light-border-2'}`}>
                  {showProfessional && (
                    <div>
                      <div className="generate-form">
                        {!isMobile ? (
                          <>
                            <div className="flex align-items-center">
                              <span style={{ color: '#888888' }} className={`${darkMode ? 'cursor-pointer-dark' : 'cursor-pointer-light'}`} onClick={hideMenuBar}>
                                <svg
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="currentColor"
                                  className="bi bi-layout-sidebar-inset"
                                >
                                  <path d="M21 3a1.5 1.5 0 0 1 1.5 1.5v15a1.5 1.5 0 0 1 -1.5 1.5H3a1.5 1.5 0 0 1 -1.5 -1.5V4.5a1.5 1.5 0 0 1 1.5 -1.5zM3 1.5a3 3 0 0 0 -3 3v15a3 3 0 0 0 3 3h18a3 3 0 0 0 3 -3V4.5a3 3 0 0 0 -3 -3z" />
                                  <path d="M4.5 6a1.5 1.5 0 0 1 1.5 -1.5h3a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1 -1.5 1.5H6a1.5 1.5 0 0 1 -1.5 -1.5z" />
                                </svg>
                              </span>
                              <h3 className={`mb-0 pl-4 ${darkMode ? 'text-white' : 'text-black'}`}>🏡 {t('app.menu.professionalMode')}</h3>
                            </div>
                            <div style={{ color: '#8c8c8c', fontSize: '14px', marginTop: '0' }}>{t('app.professionalMode.title')}</div>
                          </>
                        ) : (
                          <></>
                          // <h3 className={`${darkMode ? 'text-white' : 'text-black'}`}>🏡 {t('app.menu.professionalMode')}</h3>
                        )}
                        {/* <hr className="section-line"/> */}
                        <div className="page-header mb-0 page-header-reset mb-4" />
                        <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                          1. {t('app.professionalMode.selectPhotographer')}
                        </label>
                        <div style={{ color: '#8c8c8c', fontSize: '14px', marginTop: '0', marginBottom: '4px' }}>
                          {t('app.professionalMode.selectPhotographerSub')}
                        </div>
                        <div className="d-flex flex-column">
                          <div className="upload-title">
                            {photographerSrc && (
                              <div className="red-color" onClick={removePhotographer} style={{ marginTop: '-30px', cursor: 'pointer' }}>
                                <svg
                                  style={{ pointerEvents: 'none' }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                >
                                  <path d="M3 6L5 6 21 6"></path>
                                  <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                </svg>
                              </div>
                            )}
                          </div>
                          <div className="page-header mb-0 page-header-reset mb-2" />
                          {!photographerSrc && (
                            <div
                              className={`pose-uploader-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border light-bg-input'}`}
                              onClick={handlePhotographer}
                            >
                              <div className="uploader-title">
                                <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M7 7L5.5 5.5M15 7L16.5 5.5M5.5 16.5L7 15M11 5L11 3M5 11L3 11M17.1603 16.9887L21.0519 15.4659C21.4758 15.3001 21.4756 14.7003 21.0517 14.5346L11.6992 10.8799C11.2933 10.7213 10.8929 11.1217 11.0515 11.5276L14.7062 20.8801C14.8719 21.304 15.4717 21.3042 15.6375 20.8803L17.1603 16.9887Z"
                                    stroke="#8c8c8c"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                <span style={{ marginLeft: '4px' }}>{t('home.stylePlaceHolder')}</span>
                              </div>
                            </div>
                          )}
                          {photographerSrc && (
                            <div
                              className={`photographer-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                              onClick={handlePhotographer}
                            >
                              <div className="flex align-items-center">
                                <img src={photographerSrc} alt="Photographer Image" className="photographer-image" />
                                <span className={`photographer-name ${darkMode ? 'text-white' : 'text-black'}`}>{photographerName}</span>
                              </div>
                              <span className="detail-btn">
                                <svg
                                  fill="#757575"
                                  width="20px"
                                  height="20px"
                                  viewBox="-2.8 0 12.8 12.8"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="m1.6 8.8 2.4 -2.4 -2.4 -2.4 0.8 -0.8 3.2 3.2L2.4 9.6l-0.8 -0.8Z" />
                                </svg>
                              </span>
                            </div>
                          )}
                        </div>
                        {photographerCode === photographerStyle && (
                          <>
                            <div className="page-header mb-0 page-header-reset mb-4" />
                            <hr className="section-line" />
                            <div className="page-header mb-0 page-header-reset mb-2" />
                            <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                              2. {t('app.professionalMode.requirements')}
                            </label>
                            <div style={{ color: '#8c8c8c', fontSize: '14px', marginTop: '0', marginBottom: '4px' }}>
                              {t('app.professionalMode.guideSub')}
                            </div>
                            <div className="photographer-guide">
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>+ {t('home.uploadTitle')}</label>
                              {/* <div className="sample-selfie-wrapper">
                              <div className="good-sample-selfie-wrapper">
                                <div>{t('app.goodSelfie')}</div>
                                <img src="/images/good-selfie-woman.webp" className="sample-image" onClick={(event) => chooseSampleProfessional(event, "https://cdn.discordapp.com/attachments/1105800665105711166/1198851110669131846/1.webp", 'woman')}/>
                                <img src="/images/good-selfie-man.webp" className="sample-image" onClick={(event) => chooseSampleProfessional(event, "https://cdn.discordapp.com/attachments/1105800665105711166/1198851111092752435/2.webp", 'man')}/>
                              </div>
                              <div className="bad-sample-selfie-wrapper">
                                <div>{t('app.badSelfie')}</div>
                                <img src="/images/bad-selfie-woman.webp" className="sample-image" onClick={(event) => chooseBadSampleProfessional(event, "https://cdn.discordapp.com/attachments/1105800665105711166/1198851112334270524/4.webp", 'woman')}/>
                                <img src="/images/bad-selfie-man.webp" className="sample-image" onClick={(event) => chooseBadSampleProfessional(event, "https://cdn.discordapp.com/attachments/1105800665105711166/1198851111700942928/3.webp", 'man')}/>
                              </div>
                            </div> */}
                              <div className="d-flex flex-column">
                                <div className="upload-title">
                                  {imageSrc && (
                                    <div
                                      onClick={removeUploadedImage}
                                      style={{ marginTop: '-30px', cursor: 'pointer' }}
                                      className="red-color"
                                    >
                                      <svg
                                        style={{ pointerEvents: 'none' }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                      >
                                        <path d="M3 6L5 6 21 6"></path>
                                        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                      </svg>
                                    </div>
                                  )}
                                </div>
                                <div className="page-header mb-0 page-header-reset mb-2" />
                                {!imageSrc && (
                                  <>
                                    <div
                                      className={`uploader-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                      onClick={handleOpenFileUpload}
                                      onDragOver={handleDrag}
                                      onDragEnter={handleDrag}
                                      onDragLeave={handleDrag}
                                      onDrop={handleDrop}
                                    >
                                      <div className="uploader-title">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon"
                                          role="presentation"
                                        >
                                          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                          <polyline points="17 8 12 3 7 8" />
                                          <line x1="12" y1="3" x2="12" y2="15" />
                                        </svg>
                                        <span style={{ marginLeft: '4px' }}>{t('home.uploadPlaceHolder')}</span>
                                      </div>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileUpload}
                                        style={{ display: 'none' }}
                                        ref={fileInputRef}
                                      />
                                    </div>
                                  </>
                                )}
                                {imageSrc && (
                                  <>
                                    <div className="uploaded-wrapper">
                                      <div>
                                        <img src={imageSrc} alt="Uploaded Image" className="uploaded-image" />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.genderTitle')}
                              </label>
                              <div className="page-header mb-0 page-header-reset mb-2" />
                              <FormControl sx={{ width: '100%' }}>
                                <Select
                                  sx={{
                                    border: darkMode ? '1px solid #5d5d5d' : '',
                                    borderRadius: '8px',
                                    background: darkMode ? '#2a2a2a' : '',
                                    color: darkMode ? 'white' : 'black',
                                    '& .MuiSvgIcon-root': {
                                      color: darkMode ? 'white' : 'black',
                                    },
                                    fontSize: '14px',
                                  }}
                                  value={currentRoomType}
                                  onChange={handleChangeRoomType}
                                  autoWidth
                                >
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg width="24" height="24" viewBox="0 0 0.96 0.96" xmlns="http://www.w3.org/2000/svg" fill="#666667">
                                        <g>
                                          <path d="M.9.42H.84V.3A.03.03 0 0 0 .81.27H.54A.03.03 0 0 0 .51.3v.12H.33V.36H.27V.27h.12A.03.03 0 0 0 .414.257.03.03 0 0 0 .418.23L.358.05A.03.03 0 0 0 .33.03H.15a.03.03 0 0 0-.03.02L.06.23a.03.03 0 0 0 .004.027A.03.03 0 0 0 .09.27h.12v.09H.15v.06H.06a.03.03 0 0 0-.03.03v.09a.03.03 0 0 0 .03.03v.3A.03.03 0 0 0 .09.9h.03v.03h.06V.9h.6v.03h.06V.9h.03A.03.03 0 0 0 .9.87v-.3A.03.03 0 0 0 .93.54V.45A.03.03 0 0 0 .9.42M.132.21l.04-.12h.137l.04.12zM.57.33h.21v.09H.57ZM.09.48h.78v.03H.09Zm.09.36H.12V.57h.33v.27Zm.66 0H.51V.57h.33Z" />
                                          <path d="M.54.645H.6v.12H.54zm-.18 0h.06v.12H.36z" />
                                        </g>
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.interiorsTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {interiorsList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg width="24" height="24" viewBox="0 0 1.92 1.92" xmlns="http://www.w3.org/2000/svg" fill="#666667">
                                        <path d="M.399 1.044h.225V.819H.399zM.523.842h.079v.079h-.08zm0 .101h.079v.079h-.08zM.422.842h.079v.079H.422zm0 .101h.079v.079H.422zm.488.101h.157V.819H.91zM1 .842h.045v.079H1zm0 .101h.045v.079H1zM.933.842h.045v.079H.933zm0 .101h.045v.079H.933zm.124.44H.832v.225h.225zm-.124.202H.854v-.079h.079zm0-.101H.854v-.079h.079zm.101.101H.955v-.079h.079zm0-.101H.955v-.079h.079z" />
                                        <path d="M1.842 1.496c-.002.001-.016.005-.029.014l-.021-.011v-.044l-.018.005a.1.1 0 0 0-.029.014.1.1 0 0 0-.029-.014l-.018-.005v.033l-.016.005c-.002.001-.016.005-.029.014L1.642 1.5v-.404l.007.004c.132.091.15-.063.136-.118-.027-.104.048-.13.069-.216.037-.154-.086-.239-.048-.386s-.088-.471-.25-.239c-.054.077-.119-.061-.204.057s-.041.221-.015.298c.052.154-.052.204.016.332s-.03.191.099.262c.042.023.063.023.078.014v.126l-.344-.095V.679h.084L1.017.518V.342h.028V.285H.848v.056h.028v.087L.652.285.09.679h.084v.473l-.114.092h.114v.503H.061v.113h1.795v-.112h-.038v-.136h.006a.036.036 0 0 0 .036-.036v-.085zM1.735.601a.057.057 0 0 1 0 .113c-.031 0 .018-.025.018-.057C1.753.626 1.704.6 1.735.6M1.686.297a.038.038 0 1 1 0 .076c-.021 0 .01-.017.01-.038s-.031-.038-.01-.038m0 .62a.042.042 0 0 1 0 .084c-.023 0 0-.019 0-.042s-.023-.042 0-.042M.848.678h.281v.45H.848zm-.618 0h.562v.45H.23zm.352.909a.016.016 0 1 1 0-.033.016.016 0 1 1 0 .033m.571.159H.621V1.44h.022v-.044H.38v.044h.022v.307H.23v-.503h.923zm.198-.162h-.028v-.079h.025v.067q0 .007.003.014m-.028-.101v-.079h.045v.079zm.039.022s.02.006.033.019a.1.1 0 0 1 .033-.019v.065a.02.02 0 0 1-.022.022h-.022a.02.02 0 0 1-.022-.022zm.027.241h-.18v-.504h.206v.252l-.02.011-.004-.003v-.121h-.157v.225h.156zm-.134-.263v-.079H1.3v.079zm.045.022v.079h-.045v-.079zm.114.241H1.4v-.089a.03.03 0 0 0 .014.014zm.034 0h-.011v-.07h.011zm.005-.084h-.022a.02.02 0 0 1-.022-.022v-.034a.04.04 0 0 0 .027-.017l.006.005a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022m.028.084H1.47v-.075l.011-.009zm-.006-.187a.02.02 0 0 1-.021-.022v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022h-.009v-.004zm.053.187h-.036v-.172h.006a.04.04 0 0 0 .023-.009v.01q0 .012.007.02zm0-.291-.012.003a.1.1 0 0 0-.029.014l-.016-.009v-.221h.057zm.17.116v-.025a.03.03 0 0 0 .015.021l-.014.008-.002-.001zM1.538.558c0 .023.023.042 0 .042a.042.042 0 1 1 0-.084c.023 0 0 .019 0 .042M1.537.243c.032 0-.015.026-.015.057s.047.057.015.057a.057.057 0 1 1 0-.114m-.133.202c0-.023.019-.042.042-.042s-.007.019-.007.042.03.042.007.042a.04.04 0 0 1-.042-.042m.108.395a.084.084 0 0 1 0-.169c.047 0-.018.038-.018.084s.065.084.018.084m.061.908h-.011v-.136h.011zm.029-.172q-.002.02-.022.022h-.022a.02.02 0 0 1-.022-.022V1.51s.02.006.033.019a.1.1 0 0 1 .033-.019v.066zm.018-.004v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.067a.02.02 0 0 1-.022.022h-.022a.02.02 0 0 1-.022-.022m.027.175h-.006v-.139h.006zm.048 0h-.037v-.09a.04.04 0 0 0 .032.02h.005zm-.005-.084a.02.02 0 0 1-.022-.022v-.034a.03.03 0 0 0 .026-.017l.006.005a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022zm.05.084h-.033v-.07h.006a.04.04 0 0 0 .028-.014zm-.005-.186a.02.02 0 0 1-.022-.022v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022zm.074.186h-.057v-.172h.005l.01-.002v.003a.036.036 0 0 0 .036.036h.005v.136zm.038-.172c0 .012-.01.022-.022.022h-.022a.02.02 0 0 1-.022-.022v-.01a.04.04 0 0 0 .012-.026v-.025l.021.014a.1.1 0 0 1 .033-.019z" />
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.exteriorsTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {exteriorsList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg
                                        fill="#666667"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 0.96 0.96"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <title />
                                        <g data-name="Layer 2" id="Layer_2">
                                          <path d="M0.113 0.204a0.03 0.03 0 0 0 -0.008 0.03 0.639 0.639 0 0 0 0.136 0.24c0.022 0.024 0.045 0.046 0.067 0.066H0.24a0.03 0.03 0 0 0 -0.03 0.03v0.09a0.03 0.03 0 0 0 0.03 0.03h0.004L0.27 0.904a0.03 0.03 0 0 0 0.03 0.026h0.36a0.03 0.03 0 0 0 0.03 -0.026l0.026 -0.214H0.72a0.03 0.03 0 0 0 0.03 -0.03v-0.09a0.03 0.03 0 0 0 -0.03 -0.03h-0.07c0.022 -0.021 0.046 -0.043 0.068 -0.068a0.633 0.633 0 0 0 0.134 -0.24 0.03 0.03 0 0 0 -0.037 -0.036 0.477 0.477 0 0 0 -0.12 0.06A0.474 0.474 0 0 0 0.693 0.12a0.03 0.03 0 0 0 -0.047 -0.018 0.477 0.477 0 0 0 -0.09 0.098 0.471 0.471 0 0 0 -0.049 -0.124A0.028 0.028 0 0 0 0.48 0.06a0.03 0.03 0 0 0 -0.025 0.014 0.471 0.471 0 0 0 -0.05 0.128 0.483 0.483 0 0 0 -0.094 -0.1A0.03 0.03 0 0 0 0.263 0.12a0.465 0.465 0 0 0 0 0.134 0.462 0.462 0 0 0 -0.12 -0.057 0.03 0.03 0 0 0 -0.03 0.008M0.634 0.87H0.326l-0.022 -0.18h0.352ZM0.69 0.63H0.27v-0.03h0.42Zm-0.016 -0.198c-0.021 0.023 -0.042 0.044 -0.063 0.063l0.002 -0.004c0.007 -0.013 0.013 -0.027 0.02 -0.041l0.003 -0.006c0.007 -0.016 0.014 -0.03 0.02 -0.048s0.012 -0.032 0.018 -0.049a0.426 0.426 0 0 1 0.098 -0.069 0.564 0.564 0 0 1 -0.098 0.155m-0.035 -0.242a0.42 0.42 0 0 1 -0.02 0.131c-0.006 0.017 -0.012 0.034 -0.019 0.052l-0.011 0.027 -0.004 0.008 -0.007 0.017c-0.002 0.003 -0.003 0.007 -0.005 0.01s-0.004 0.01 -0.007 0.014 -0.003 0.007 -0.005 0.01 -0.004 0.009 -0.007 0.013l-0.005 0.01c-0.002 0.004 -0.004 0.008 -0.007 0.012l-0.005 0.009 -0.007 0.011c-0.002 0.003 -0.003 0.005 -0.005 0.007l-0.007 0.01c-0.002 0.002 -0.003 0.004 -0.004 0.006l-0.002 0.002h-0.019v-0.01c0 -0.01 0.003 -0.021 0.005 -0.032 0 -0.004 0.002 -0.008 0.002 -0.011 0.002 -0.008 0.003 -0.016 0.005 -0.024a0.96 0.96 0 0 1 0.035 -0.111c0.007 -0.018 0.014 -0.035 0.022 -0.052a0.423 0.423 0 0 1 0.073 -0.109M0.48 0.16a0.438 0.438 0 0 1 0.028 0.12 0.03 0.03 0 0 0 -0.002 0.005q-0.01 0.021 -0.018 0.043l-0.009 0.024q-0.004 -0.012 -0.009 -0.023c-0.005 -0.014 -0.011 -0.027 -0.017 -0.04l-0.002 -0.004A0.441 0.441 0 0 1 0.48 0.16m-0.086 0.144c0.007 0.015 0.014 0.03 0.02 0.048s0.014 0.037 0.02 0.055c0.002 0.006 0.003 0.011 0.005 0.017 0.003 0.011 0.007 0.022 0.009 0.032s-0.003 0.013 -0.004 0.02 -0.002 0.009 -0.003 0.013c-0.002 0.012 -0.004 0.023 -0.005 0.034a0.012 0.012 0 0 0 0 0.003l-0.002 -0.003q-0.009 -0.013 -0.017 -0.027l-0.002 -0.004c-0.005 -0.009 -0.011 -0.019 -0.016 -0.03l-0.003 -0.005c-0.006 -0.011 -0.011 -0.023 -0.017 -0.036 0 -0.002 -0.002 -0.005 -0.003 -0.007 -0.006 -0.013 -0.011 -0.026 -0.017 -0.04 -0.007 -0.018 -0.013 -0.036 -0.019 -0.053a0.423 0.423 0 0 1 -0.021 -0.13 0.432 0.432 0 0 1 0.076 0.114Zm-0.109 0.043 0.002 0.006a1.023 1.023 0 0 0 0.036 0.091 0.045 0.045 0 0 1 0.003 0.007c0.007 0.014 0.013 0.028 0.02 0.041l0.002 0.004c-0.021 -0.019 -0.042 -0.04 -0.063 -0.062a0.57 0.57 0 0 1 -0.099 -0.154 0.441 0.441 0 0 1 0.099 0.068" />
                                        </g>
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.gardensTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {gardensList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.styleTitle')}
                              </label>
                              <div className="d-flex flex-column">
                                <div className="upload-title">
                                  {styleSrc && (
                                    <div
                                      onClick={removeUploadedStyle}
                                      style={{ marginTop: '-30px', cursor: 'pointer' }}
                                      className="red-color"
                                    >
                                      <svg
                                        style={{ pointerEvents: 'none' }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                      >
                                        <path d="M3 6L5 6 21 6"></path>
                                        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                      </svg>
                                    </div>
                                  )}
                                </div>
                                <div className="page-header mb-0 page-header-reset mb-2" />
                                {!styleSrc && (
                                  <div
                                    className={`pose-uploader-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                    onClick={handleStyleUpload}
                                  >
                                    <div className="uploader-title">
                                      <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M7 7L5.5 5.5M15 7L16.5 5.5M5.5 16.5L7 15M11 5L11 3M5 11L3 11M17.1603 16.9887L21.0519 15.4659C21.4758 15.3001 21.4756 14.7003 21.0517 14.5346L11.6992 10.8799C11.2933 10.7213 10.8929 11.1217 11.0515 11.5276L14.7062 20.8801C14.8719 21.304 15.4717 21.3042 15.6375 20.8803L17.1603 16.9887Z"
                                          stroke="#8c8c8c"
                                          strokeWidth="1.6"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('home.stylePlaceHolder')}</span>
                                    </div>
                                  </div>
                                )}
                                {styleSrc && (
                                  <div
                                    className={`photographer-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                    onClick={handleStyleUpload}
                                  >
                                    <div className="flex align-items-center">
                                      <img src={styleSrc} alt="Style Image" className="photographer-image" />
                                      <span className={`photographer-name ${darkMode ? 'text-white' : 'text-black'}`}>
                                        {t(`styles.${styleCode}`)}
                                      </span>
                                    </div>
                                    <span className="detail-btn">
                                      <svg
                                        fill="#757575"
                                        width="20px"
                                        height="20px"
                                        viewBox="-2.8 0 12.8 12.8"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="m1.6 8.8 2.4 -2.4 -2.4 -2.4 0.8 -0.8 3.2 3.2L2.4 9.6l-0.8 -0.8Z" />
                                      </svg>
                                    </span>
                                  </div>
                                )}
                              </div>
                              {currentLanguage === 'en' ? (
                                <>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <div className="sample-image-wrapper">
                                    <span>
                                      {t('app.professionalMode.customize')}
                                    </span>
                                  </div>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <TextField
                                    value={promptStyle}
                                    sx={{
                                      width: '100%',
                                      border: darkMode ? '1px solid #5d5d5d' : '',
                                      borderRadius: '6px',
                                      background: darkMode ? '#2a2a2a' : '',
                                      color: darkMode ? 'white' : 'black',
                                      fontSize: isMobile ? '16px' : '14px',
                                    }}
                                    maxRows={10}
                                    minRows={3}
                                    multiline
                                    onChange={handleInputChange}
                                    placeholder="A modern house..."
                                    inputProps={{
                                      style: {
                                        fontSize: isMobile ? '16px' : '14px',
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    InputLabelProps={{
                                      style: {
                                        fontSize: isMobile ? '16px' : '14px',
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    error={!!promptErrorMessage}
                                    helperText={promptErrorMessage}
                                    autoFocus={false}
                                  />
                                </>
                              ) : (
                                <>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <div className="sample-image-wrapper">
                                    <span>
                                      {t('app.professionalMode.enOnlyCustomize')}
                                    </span>
                                  </div>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <TextField
                                    disabled={true}
                                    value={promptStyle}
                                    sx={{
                                      width: '100%',
                                      border: darkMode ? '1px solid #5d5d5d' : '',
                                      borderRadius: '6px',
                                      background: darkMode ? '#2a2a2a' : '',
                                      color: darkMode ? 'white' : 'black',
                                      fontSize: isMobile ? '16px' : '14px',
                                    }}
                                    maxRows={3}
                                    minRows={3}
                                    multiline
                                    onChange={handleInputChange}
                                    placeholder="A modern house..."
                                    inputProps={{
                                      style: {
                                        fontSize: isMobile ? '16px' : '14px',
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    InputLabelProps={{
                                      style: {
                                        fontSize: isMobile ? '16px' : '14px',
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    error={!!promptErrorMessage}
                                    helperText={promptErrorMessage}
                                  />
                                </>
                              )}
                              {/* <div className="page-header mb-0 page-header-reset mb-4" />
                            <label className={`${darkMode? 'text-white' : 'text-black'}`}>+ {t('app.professionalMode.backgroundTitle')}</label>
                            <div className="d-flex flex-column">
                              <div className="upload-title">
                                {backgroundSrc && (
                                  <div onClick={removeUploadedBackground} style={{ marginTop: '-25px', cursor: "pointer" }} className='red-color'>
                                    <svg
                                      style={{pointerEvents: "none"}}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="14"
                                      height="14"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                    >
                                      <path d="M3 6L5 6 21 6"></path>
                                      <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                    </svg>
                                  </div>
                                )}
                              </div>
                              <div className="page-header mb-0 page-header-reset mb-2" />
                              {!backgroundSrc && (
                                <div
                                  className={`pose-uploader-wrapper ${darkMode? 'dark-border dark-bg-input' : 'light-border'}`}
                                  onClick={handleBackgroundUpload}
                                >
                                  <div className="uploader-title">
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M7 7L5.5 5.5M15 7L16.5 5.5M5.5 16.5L7 15M11 5L11 3M5 11L3 11M17.1603 16.9887L21.0519 15.4659C21.4758 15.3001 21.4756 14.7003 21.0517 14.5346L11.6992 10.8799C11.2933 10.7213 10.8929 11.1217 11.0515 11.5276L14.7062 20.8801C14.8719 21.304 15.4717 21.3042 15.6375 20.8803L17.1603 16.9887Z" stroke="#8c8c8c" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                    <span style={{ marginLeft: '4px' }}>{t('home.stylePlaceHolder')}</span>
                                  </div>
                                </div>
                              )}
                              {backgroundSrc && (
                                <div className={`photographer-wrapper ${darkMode? 'dark-border dark-bg-input' : 'light-border'}`}                                onClick={handleBackgroundUpload}>
                                  <div className="flex align-items-center">
                                    <img src={backgroundSrc} alt="Style Image" className="photographer-image" />
                                    {promptBackground !== "" ? 
                                    <span 
                                      className={`photographer-name ${darkMode? 'text-white' : 'text-black'}`}
                                    >{backgroundName}</span>
                                    :
                                    <span
                                      className={`photographer-name ${darkMode? 'text-white' : 'text-black'}`}
                                    >{t(`backgrounds.${backgroundCode}`)}</span>
                                    }
                                  </div>
                                  <span className="detail-btn">
                                    <svg fill="#757575" width="20px" height="20px" viewBox="-2.8 0 12.8 12.8" xmlns="http://www.w3.org/2000/svg">
                                      <path d="m1.6 8.8 2.4 -2.4 -2.4 -2.4 0.8 -0.8 3.2 3.2L2.4 9.6l-0.8 -0.8Z"/>
                                    </svg>
                                  </span>
                                </div>
                              )}
                            </div> */}
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.creativity')}
                              </label>
                              {renderStrength()}
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.quantityTitle')}
                              </label>
                              <div className="page-header mb-0 page-header-reset mb-2" />
                              <FormControl sx={{ width: '100%' }}>
                                <Select
                                  sx={{
                                    border: darkMode ? '1px solid #5d5d5d' : '',
                                    borderRadius: '8px',
                                    background: darkMode ? '#2a2a2a' : '',
                                    color: darkMode ? 'white' : 'black',
                                    '& .MuiSvgIcon-root': {
                                      color: darkMode ? 'white' : 'black',
                                    },
                                    fontSize: '14px',
                                  }}
                                  value={currentResult}
                                  onChange={handleChangeResult}
                                  autoWidth
                                >
                                  {results.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.value}>
                                        {t(`results.${c.label}`)}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                          </>
                        )}
                        {photographerCode === photographerPose && (
                          <>
                            <div className="page-header mb-0 page-header-reset mb-4" />
                            <hr className="section-line" />
                            <div className="page-header mb-0 page-header-reset mb-2" />
                            <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                              2. {t('app.professionalMode.requirements')}
                            </label>
                            <div style={{ color: '#8c8c8c', fontSize: '14px', marginTop: '0', marginBottom: '4px' }}>
                              {t('app.professionalMode.guideSub')}
                            </div>
                            <div className="photographer-guide">
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>+ {t('home.uploadTitle')}</label>
                              {/* <div className="sample-selfie-wrapper">
                              <div className="good-sample-selfie-wrapper">
                                <div>{t('app.goodSelfie')}</div>
                                <img src="/images/good-selfie-woman.webp" className="sample-image" onClick={(event) => chooseSampleProfessional(event, "https://cdn.discordapp.com/attachments/1105800665105711166/1198851110669131846/1.webp", 'woman')}/>
                                <img src="/images/good-selfie-man.webp" className="sample-image" onClick={(event) => chooseSampleProfessional(event, "https://cdn.discordapp.com/attachments/1105800665105711166/1198851111092752435/2.webp", 'man')}/>
                              </div>
                              <div className="bad-sample-selfie-wrapper">
                                <div>{t('app.badSelfie')}</div>
                                <img src="/images/bad-selfie-woman.webp" className="sample-image" onClick={(event) => chooseBadSampleProfessional(event, "https://cdn.discordapp.com/attachments/1105800665105711166/1198851112334270524/4.webp", 'woman')}/>
                                <img src="/images/bad-selfie-man.webp" className="sample-image" onClick={(event) => chooseBadSampleProfessional(event, "https://cdn.discordapp.com/attachments/1105800665105711166/1198851111700942928/3.webp", 'man')}/>
                              </div>
                            </div> */}
                              <div className="d-flex flex-column">
                                <div className="upload-title">
                                  {imageSrc && (
                                    <div
                                      onClick={removeUploadedImage}
                                      style={{ marginTop: '-30px', cursor: 'pointer' }}
                                      className="red-color"
                                    >
                                      <svg
                                        style={{ pointerEvents: 'none' }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                      >
                                        <path d="M3 6L5 6 21 6"></path>
                                        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                      </svg>
                                    </div>
                                  )}
                                </div>
                                <div className="page-header mb-0 page-header-reset mb-2" />
                                {!imageSrc && (
                                  <>
                                    <div
                                      className={`uploader-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                      onClick={handleOpenFileUpload}
                                      onDragOver={handleDrag}
                                      onDragEnter={handleDrag}
                                      onDragLeave={handleDrag}
                                      onDrop={handleDrop}
                                    >
                                      <div className="uploader-title">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon"
                                          role="presentation"
                                        >
                                          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                          <polyline points="17 8 12 3 7 8" />
                                          <line x1="12" y1="3" x2="12" y2="15" />
                                        </svg>
                                        <span style={{ marginLeft: '4px' }}>{t('home.uploadPlaceHolder')}</span>
                                      </div>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileUpload}
                                        style={{ display: 'none' }}
                                        ref={fileInputRef}
                                      />
                                    </div>
                                  </>
                                )}
                                {imageSrc && (
                                  <>
                                    <div className="uploaded-wrapper">
                                      <div>
                                        <img src={imageSrc} alt="Uploaded Image" className="uploaded-image" />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.genderTitle')}
                              </label>
                              <div className="page-header mb-0 page-header-reset mb-2" />
                              <FormControl sx={{ width: '100%' }}>
                                <Select
                                  sx={{
                                    border: darkMode ? '1px solid #5d5d5d' : '',
                                    borderRadius: '8px',
                                    background: darkMode ? '#2a2a2a' : '',
                                    color: darkMode ? 'white' : 'black',
                                    '& .MuiSvgIcon-root': {
                                      color: darkMode ? 'white' : 'black',
                                    },
                                    fontSize: '14px',
                                  }}
                                  value={currentRoomType}
                                  onChange={handleChangeRoomType}
                                  autoWidth
                                >
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg width="24" height="24" viewBox="0 0 0.96 0.96" xmlns="http://www.w3.org/2000/svg" fill="#666667">
                                        <g>
                                          <path d="M.9.42H.84V.3A.03.03 0 0 0 .81.27H.54A.03.03 0 0 0 .51.3v.12H.33V.36H.27V.27h.12A.03.03 0 0 0 .414.257.03.03 0 0 0 .418.23L.358.05A.03.03 0 0 0 .33.03H.15a.03.03 0 0 0-.03.02L.06.23a.03.03 0 0 0 .004.027A.03.03 0 0 0 .09.27h.12v.09H.15v.06H.06a.03.03 0 0 0-.03.03v.09a.03.03 0 0 0 .03.03v.3A.03.03 0 0 0 .09.9h.03v.03h.06V.9h.6v.03h.06V.9h.03A.03.03 0 0 0 .9.87v-.3A.03.03 0 0 0 .93.54V.45A.03.03 0 0 0 .9.42M.132.21l.04-.12h.137l.04.12zM.57.33h.21v.09H.57ZM.09.48h.78v.03H.09Zm.09.36H.12V.57h.33v.27Zm.66 0H.51V.57h.33Z" />
                                          <path d="M.54.645H.6v.12H.54zm-.18 0h.06v.12H.36z" />
                                        </g>
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.interiorsTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {interiorsList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg width="24" height="24" viewBox="0 0 1.92 1.92" xmlns="http://www.w3.org/2000/svg" fill="#666667">
                                        <path d="M.399 1.044h.225V.819H.399zM.523.842h.079v.079h-.08zm0 .101h.079v.079h-.08zM.422.842h.079v.079H.422zm0 .101h.079v.079H.422zm.488.101h.157V.819H.91zM1 .842h.045v.079H1zm0 .101h.045v.079H1zM.933.842h.045v.079H.933zm0 .101h.045v.079H.933zm.124.44H.832v.225h.225zm-.124.202H.854v-.079h.079zm0-.101H.854v-.079h.079zm.101.101H.955v-.079h.079zm0-.101H.955v-.079h.079z" />
                                        <path d="M1.842 1.496c-.002.001-.016.005-.029.014l-.021-.011v-.044l-.018.005a.1.1 0 0 0-.029.014.1.1 0 0 0-.029-.014l-.018-.005v.033l-.016.005c-.002.001-.016.005-.029.014L1.642 1.5v-.404l.007.004c.132.091.15-.063.136-.118-.027-.104.048-.13.069-.216.037-.154-.086-.239-.048-.386s-.088-.471-.25-.239c-.054.077-.119-.061-.204.057s-.041.221-.015.298c.052.154-.052.204.016.332s-.03.191.099.262c.042.023.063.023.078.014v.126l-.344-.095V.679h.084L1.017.518V.342h.028V.285H.848v.056h.028v.087L.652.285.09.679h.084v.473l-.114.092h.114v.503H.061v.113h1.795v-.112h-.038v-.136h.006a.036.036 0 0 0 .036-.036v-.085zM1.735.601a.057.057 0 0 1 0 .113c-.031 0 .018-.025.018-.057C1.753.626 1.704.6 1.735.6M1.686.297a.038.038 0 1 1 0 .076c-.021 0 .01-.017.01-.038s-.031-.038-.01-.038m0 .62a.042.042 0 0 1 0 .084c-.023 0 0-.019 0-.042s-.023-.042 0-.042M.848.678h.281v.45H.848zm-.618 0h.562v.45H.23zm.352.909a.016.016 0 1 1 0-.033.016.016 0 1 1 0 .033m.571.159H.621V1.44h.022v-.044H.38v.044h.022v.307H.23v-.503h.923zm.198-.162h-.028v-.079h.025v.067q0 .007.003.014m-.028-.101v-.079h.045v.079zm.039.022s.02.006.033.019a.1.1 0 0 1 .033-.019v.065a.02.02 0 0 1-.022.022h-.022a.02.02 0 0 1-.022-.022zm.027.241h-.18v-.504h.206v.252l-.02.011-.004-.003v-.121h-.157v.225h.156zm-.134-.263v-.079H1.3v.079zm.045.022v.079h-.045v-.079zm.114.241H1.4v-.089a.03.03 0 0 0 .014.014zm.034 0h-.011v-.07h.011zm.005-.084h-.022a.02.02 0 0 1-.022-.022v-.034a.04.04 0 0 0 .027-.017l.006.005a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022m.028.084H1.47v-.075l.011-.009zm-.006-.187a.02.02 0 0 1-.021-.022v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022h-.009v-.004zm.053.187h-.036v-.172h.006a.04.04 0 0 0 .023-.009v.01q0 .012.007.02zm0-.291-.012.003a.1.1 0 0 0-.029.014l-.016-.009v-.221h.057zm.17.116v-.025a.03.03 0 0 0 .015.021l-.014.008-.002-.001zM1.538.558c0 .023.023.042 0 .042a.042.042 0 1 1 0-.084c.023 0 0 .019 0 .042M1.537.243c.032 0-.015.026-.015.057s.047.057.015.057a.057.057 0 1 1 0-.114m-.133.202c0-.023.019-.042.042-.042s-.007.019-.007.042.03.042.007.042a.04.04 0 0 1-.042-.042m.108.395a.084.084 0 0 1 0-.169c.047 0-.018.038-.018.084s.065.084.018.084m.061.908h-.011v-.136h.011zm.029-.172q-.002.02-.022.022h-.022a.02.02 0 0 1-.022-.022V1.51s.02.006.033.019a.1.1 0 0 1 .033-.019v.066zm.018-.004v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.067a.02.02 0 0 1-.022.022h-.022a.02.02 0 0 1-.022-.022m.027.175h-.006v-.139h.006zm.048 0h-.037v-.09a.04.04 0 0 0 .032.02h.005zm-.005-.084a.02.02 0 0 1-.022-.022v-.034a.03.03 0 0 0 .026-.017l.006.005a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022zm.05.084h-.033v-.07h.006a.04.04 0 0 0 .028-.014zm-.005-.186a.02.02 0 0 1-.022-.022v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022zm.074.186h-.057v-.172h.005l.01-.002v.003a.036.036 0 0 0 .036.036h.005v.136zm.038-.172c0 .012-.01.022-.022.022h-.022a.02.02 0 0 1-.022-.022v-.01a.04.04 0 0 0 .012-.026v-.025l.021.014a.1.1 0 0 1 .033-.019z" />
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.exteriorsTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {exteriorsList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg
                                        fill="#666667"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 0.96 0.96"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <title />
                                        <g data-name="Layer 2" id="Layer_2">
                                          <path d="M0.113 0.204a0.03 0.03 0 0 0 -0.008 0.03 0.639 0.639 0 0 0 0.136 0.24c0.022 0.024 0.045 0.046 0.067 0.066H0.24a0.03 0.03 0 0 0 -0.03 0.03v0.09a0.03 0.03 0 0 0 0.03 0.03h0.004L0.27 0.904a0.03 0.03 0 0 0 0.03 0.026h0.36a0.03 0.03 0 0 0 0.03 -0.026l0.026 -0.214H0.72a0.03 0.03 0 0 0 0.03 -0.03v-0.09a0.03 0.03 0 0 0 -0.03 -0.03h-0.07c0.022 -0.021 0.046 -0.043 0.068 -0.068a0.633 0.633 0 0 0 0.134 -0.24 0.03 0.03 0 0 0 -0.037 -0.036 0.477 0.477 0 0 0 -0.12 0.06A0.474 0.474 0 0 0 0.693 0.12a0.03 0.03 0 0 0 -0.047 -0.018 0.477 0.477 0 0 0 -0.09 0.098 0.471 0.471 0 0 0 -0.049 -0.124A0.028 0.028 0 0 0 0.48 0.06a0.03 0.03 0 0 0 -0.025 0.014 0.471 0.471 0 0 0 -0.05 0.128 0.483 0.483 0 0 0 -0.094 -0.1A0.03 0.03 0 0 0 0.263 0.12a0.465 0.465 0 0 0 0 0.134 0.462 0.462 0 0 0 -0.12 -0.057 0.03 0.03 0 0 0 -0.03 0.008M0.634 0.87H0.326l-0.022 -0.18h0.352ZM0.69 0.63H0.27v-0.03h0.42Zm-0.016 -0.198c-0.021 0.023 -0.042 0.044 -0.063 0.063l0.002 -0.004c0.007 -0.013 0.013 -0.027 0.02 -0.041l0.003 -0.006c0.007 -0.016 0.014 -0.03 0.02 -0.048s0.012 -0.032 0.018 -0.049a0.426 0.426 0 0 1 0.098 -0.069 0.564 0.564 0 0 1 -0.098 0.155m-0.035 -0.242a0.42 0.42 0 0 1 -0.02 0.131c-0.006 0.017 -0.012 0.034 -0.019 0.052l-0.011 0.027 -0.004 0.008 -0.007 0.017c-0.002 0.003 -0.003 0.007 -0.005 0.01s-0.004 0.01 -0.007 0.014 -0.003 0.007 -0.005 0.01 -0.004 0.009 -0.007 0.013l-0.005 0.01c-0.002 0.004 -0.004 0.008 -0.007 0.012l-0.005 0.009 -0.007 0.011c-0.002 0.003 -0.003 0.005 -0.005 0.007l-0.007 0.01c-0.002 0.002 -0.003 0.004 -0.004 0.006l-0.002 0.002h-0.019v-0.01c0 -0.01 0.003 -0.021 0.005 -0.032 0 -0.004 0.002 -0.008 0.002 -0.011 0.002 -0.008 0.003 -0.016 0.005 -0.024a0.96 0.96 0 0 1 0.035 -0.111c0.007 -0.018 0.014 -0.035 0.022 -0.052a0.423 0.423 0 0 1 0.073 -0.109M0.48 0.16a0.438 0.438 0 0 1 0.028 0.12 0.03 0.03 0 0 0 -0.002 0.005q-0.01 0.021 -0.018 0.043l-0.009 0.024q-0.004 -0.012 -0.009 -0.023c-0.005 -0.014 -0.011 -0.027 -0.017 -0.04l-0.002 -0.004A0.441 0.441 0 0 1 0.48 0.16m-0.086 0.144c0.007 0.015 0.014 0.03 0.02 0.048s0.014 0.037 0.02 0.055c0.002 0.006 0.003 0.011 0.005 0.017 0.003 0.011 0.007 0.022 0.009 0.032s-0.003 0.013 -0.004 0.02 -0.002 0.009 -0.003 0.013c-0.002 0.012 -0.004 0.023 -0.005 0.034a0.012 0.012 0 0 0 0 0.003l-0.002 -0.003q-0.009 -0.013 -0.017 -0.027l-0.002 -0.004c-0.005 -0.009 -0.011 -0.019 -0.016 -0.03l-0.003 -0.005c-0.006 -0.011 -0.011 -0.023 -0.017 -0.036 0 -0.002 -0.002 -0.005 -0.003 -0.007 -0.006 -0.013 -0.011 -0.026 -0.017 -0.04 -0.007 -0.018 -0.013 -0.036 -0.019 -0.053a0.423 0.423 0 0 1 -0.021 -0.13 0.432 0.432 0 0 1 0.076 0.114Zm-0.109 0.043 0.002 0.006a1.023 1.023 0 0 0 0.036 0.091 0.045 0.045 0 0 1 0.003 0.007c0.007 0.014 0.013 0.028 0.02 0.041l0.002 0.004c-0.021 -0.019 -0.042 -0.04 -0.063 -0.062a0.57 0.57 0 0 1 -0.099 -0.154 0.441 0.441 0 0 1 0.099 0.068" />
                                        </g>
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.gardensTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {gardensList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.styleTitle')}
                              </label>
                              <div className="d-flex flex-column">
                                <div className="upload-title">
                                  {styleSrc && (
                                    <div
                                      onClick={removeUploadedStyle}
                                      style={{ marginTop: '-30px', cursor: 'pointer' }}
                                      className="red-color"
                                    >
                                      <svg
                                        style={{ pointerEvents: 'none' }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                      >
                                        <path d="M3 6L5 6 21 6"></path>
                                        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                      </svg>
                                    </div>
                                  )}
                                </div>
                                <div className="page-header mb-0 page-header-reset mb-2" />
                                {!styleSrc && (
                                  <div
                                    className={`pose-uploader-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                    onClick={handleStyleUpload}
                                  >
                                    <div className="uploader-title">
                                      <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M7 7L5.5 5.5M15 7L16.5 5.5M5.5 16.5L7 15M11 5L11 3M5 11L3 11M17.1603 16.9887L21.0519 15.4659C21.4758 15.3001 21.4756 14.7003 21.0517 14.5346L11.6992 10.8799C11.2933 10.7213 10.8929 11.1217 11.0515 11.5276L14.7062 20.8801C14.8719 21.304 15.4717 21.3042 15.6375 20.8803L17.1603 16.9887Z"
                                          stroke="#8c8c8c"
                                          strokeWidth="1.6"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('home.stylePlaceHolder')}</span>
                                    </div>
                                  </div>
                                )}
                                {styleSrc && (
                                  <div
                                    className={`photographer-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                    onClick={handleStyleUpload}
                                  >
                                    <div className="flex align-items-center">
                                      <img src={styleSrc} alt="Style Image" className="photographer-image" />
                                      <span className={`photographer-name ${darkMode ? 'text-white' : 'text-black'}`}>
                                        {t(`styles.${styleCode}`)}
                                      </span>
                                    </div>
                                    <span className="detail-btn">
                                      <svg
                                        fill="#757575"
                                        width="20px"
                                        height="20px"
                                        viewBox="-2.8 0 12.8 12.8"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="m1.6 8.8 2.4 -2.4 -2.4 -2.4 0.8 -0.8 3.2 3.2L2.4 9.6l-0.8 -0.8Z" />
                                      </svg>
                                    </span>
                                  </div>
                                )}
                              </div>
                              {currentLanguage === 'en' ? (
                                <>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <div className="sample-image-wrapper">
                                    <span>
                                      {t('app.professionalMode.customize')}
                                    </span>
                                  </div>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <TextField
                                    value={promptStyle}
                                    sx={{
                                      width: '100%',
                                      border: darkMode ? '1px solid #5d5d5d' : '',
                                      borderRadius: '6px',
                                      background: darkMode ? '#2a2a2a' : '',
                                      color: darkMode ? 'white' : 'black',
                                      fontSize: '14px',
                                    }}
                                    maxRows={10}
                                    minRows={3}
                                    multiline
                                    onChange={handleInputChange}
                                    placeholder="A modern house..."
                                    inputProps={{
                                      style: {
                                        fontSize: 14,
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    InputLabelProps={{
                                      style: {
                                        fontSize: 14,
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    error={!!promptErrorMessage}
                                    helperText={promptErrorMessage}
                                  />
                                </>
                              ) : (
                                <>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <div className="sample-image-wrapper">
                                    <span>
                                      {t('app.professionalMode.enOnlyCustomize')}
                                    </span>
                                  </div>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <TextField
                                    disabled={true}
                                    value={promptStyle}
                                    sx={{
                                      width: '100%',
                                      border: darkMode ? '1px solid #5d5d5d' : '',
                                      borderRadius: '6px',
                                      background: darkMode ? '#2a2a2a' : '',
                                      color: darkMode ? 'white' : 'black',
                                      fontSize: isMobile ? '16px' : '14px',
                                    }}
                                    maxRows={3}
                                    minRows={3}
                                    multiline
                                    onChange={handleInputChange}
                                    placeholder="A modern house..."
                                    inputProps={{
                                      style: {
                                        fontSize: isMobile ? '16px' : '14px',
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    InputLabelProps={{
                                      style: {
                                        fontSize: isMobile ? '16px' : '14px',
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    error={!!promptErrorMessage}
                                    helperText={promptErrorMessage}
                                  />
                                </>
                              )}
                              {/* <div className="page-header mb-0 page-header-reset mb-4" />
                            <label className={`${darkMode? 'text-white' : 'text-black'}`}>+ {t('app.professionalMode.backgroundTitle')}</label>
                            <div className="d-flex flex-column">
                              <div className="upload-title">
                                {backgroundSrc && (
                                  <div onClick={removeUploadedBackground} style={{ marginTop: '-25px', cursor: "pointer" }} className='red-color'>
                                    <svg
                                      style={{pointerEvents: "none"}}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="14"
                                      height="14"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                    >
                                      <path d="M3 6L5 6 21 6"></path>
                                      <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                    </svg>
                                  </div>
                                )}
                              </div>
                              <div className="page-header mb-0 page-header-reset mb-2" />
                              {!backgroundSrc && (
                                <div
                                  className={`pose-uploader-wrapper ${darkMode? 'dark-border dark-bg-input' : 'light-border'}`}
                                  onClick={handleBackgroundUpload}
                                >
                                  <div className="uploader-title">
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M7 7L5.5 5.5M15 7L16.5 5.5M5.5 16.5L7 15M11 5L11 3M5 11L3 11M17.1603 16.9887L21.0519 15.4659C21.4758 15.3001 21.4756 14.7003 21.0517 14.5346L11.6992 10.8799C11.2933 10.7213 10.8929 11.1217 11.0515 11.5276L14.7062 20.8801C14.8719 21.304 15.4717 21.3042 15.6375 20.8803L17.1603 16.9887Z" stroke="#8c8c8c" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                      </svg>
                                    <span style={{ marginLeft: '4px' }}>{t('home.stylePlaceHolder')}</span>
                                  </div>
                                </div>
                              )}
                              {backgroundSrc && (
                                <div className={`photographer-wrapper ${darkMode? 'dark-border dark-bg-input' : 'light-border'}`}                                onClick={handleBackgroundUpload}>
                                  <div className="flex align-items-center">
                                    <img src={backgroundSrc} alt="Style Image" className="photographer-image" />
                                    {promptBackground !== "" ? 
                                    <span 
                                      className={`photographer-name ${darkMode? 'text-white' : 'text-black'}`}
                                    >{backgroundName}</span>
                                    :
                                    <span
                                      className={`photographer-name ${darkMode? 'text-white' : 'text-black'}`}
                                    >{t(`backgrounds.${backgroundCode}`)}</span>
                                    }
                                  </div>
                                  <span className="detail-btn">
                                    <svg fill="#757575" width="20px" height="20px" viewBox="-2.8 0 12.8 12.8" xmlns="http://www.w3.org/2000/svg">
                                      <path d="m1.6 8.8 2.4 -2.4 -2.4 -2.4 0.8 -0.8 3.2 3.2L2.4 9.6l-0.8 -0.8Z"/>
                                    </svg>
                                  </span>
                                </div>
                              )}
                            </div> */}
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.creativity')}
                              </label>
                              {renderStrength()}
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.quantityTitle')}
                              </label>
                              <div className="page-header mb-0 page-header-reset mb-2" />
                              <FormControl sx={{ width: '100%' }}>
                                <Select
                                  sx={{
                                    border: darkMode ? '1px solid #5d5d5d' : '',
                                    borderRadius: '8px',
                                    background: darkMode ? '#2a2a2a' : '',
                                    color: darkMode ? 'white' : 'black',
                                    '& .MuiSvgIcon-root': {
                                      color: darkMode ? 'white' : 'black',
                                    },
                                    fontSize: '14px',
                                  }}
                                  value={currentResult}
                                  onChange={handleChangeResult}
                                  autoWidth
                                >
                                  {results.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.value}>
                                        {t(`results.${c.label}`)}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </div>
                          </>
                        )}
                        {photographerCode === photographerRemodeling && (
                          <>
                            <div className="page-header mb-0 page-header-reset mb-4" />
                            <hr className="section-line" />
                            <div className="page-header mb-0 page-header-reset mb-2" />
                            <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                              2. {t('app.professionalMode.requirements')}
                            </label>
                            <div style={{ color: '#8c8c8c', fontSize: '14px', marginTop: '0', marginBottom: '4px' }}>
                              {t('app.professionalMode.guideSub')}
                            </div>
                            <div className="photographer-guide">
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>+ {t('home.uploadTitle')}</label>
                              <div className="d-flex flex-column">
                                <div className="upload-title">
                                  {imageSrc && (
                                    <div
                                      onClick={removeUploadedImage}
                                      style={{ marginTop: '-30px', cursor: 'pointer' }}
                                      className="red-color"
                                    >
                                      <svg
                                        style={{ pointerEvents: 'none' }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                      >
                                        <path d="M3 6L5 6 21 6"></path>
                                        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                      </svg>
                                    </div>
                                  )}
                                </div>
                                <div className="page-header mb-0 page-header-reset mb-2" />
                                {!imageSrc && (
                                  <>
                                    <div
                                      className={`uploader-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                      onClick={handleOpenFileUpload}
                                      onDragOver={handleDrag}
                                      onDragEnter={handleDrag}
                                      onDragLeave={handleDrag}
                                      onDrop={handleDrop}
                                    >
                                      <div className="uploader-title">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon"
                                          role="presentation"
                                        >
                                          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                                          <polyline points="17 8 12 3 7 8" />
                                          <line x1="12" y1="3" x2="12" y2="15" />
                                        </svg>
                                        <span style={{ marginLeft: '4px' }}>{t('home.uploadPlaceHolder')}</span>
                                      </div>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileUpload}
                                        style={{ display: 'none' }}
                                        ref={fileInputRef}
                                      />
                                    </div>
                                  </>
                                )}
                                {imageSrc && (
                                  <>
                                    <div className="uploaded-wrapper">
                                      <div>
                                        <img src={imageSrc} alt="Uploaded Image" className="uploaded-image" />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.genderTitle')}
                              </label>
                              <div className="page-header mb-0 page-header-reset mb-2" />
                              <FormControl sx={{ width: '100%' }}>
                                <Select
                                  sx={{
                                    border: darkMode ? '1px solid #5d5d5d' : '',
                                    borderRadius: '8px',
                                    background: darkMode ? '#2a2a2a' : '',
                                    color: darkMode ? 'white' : 'black',
                                    '& .MuiSvgIcon-root': {
                                      color: darkMode ? 'white' : 'black',
                                    },
                                    fontSize: '14px',
                                  }}
                                  value={currentRoomType}
                                  onChange={handleChangeRoomType}
                                  autoWidth
                                >
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg width="24" height="24" viewBox="0 0 0.96 0.96" xmlns="http://www.w3.org/2000/svg" fill="#666667">
                                        <g>
                                          <path d="M.9.42H.84V.3A.03.03 0 0 0 .81.27H.54A.03.03 0 0 0 .51.3v.12H.33V.36H.27V.27h.12A.03.03 0 0 0 .414.257.03.03 0 0 0 .418.23L.358.05A.03.03 0 0 0 .33.03H.15a.03.03 0 0 0-.03.02L.06.23a.03.03 0 0 0 .004.027A.03.03 0 0 0 .09.27h.12v.09H.15v.06H.06a.03.03 0 0 0-.03.03v.09a.03.03 0 0 0 .03.03v.3A.03.03 0 0 0 .09.9h.03v.03h.06V.9h.6v.03h.06V.9h.03A.03.03 0 0 0 .9.87v-.3A.03.03 0 0 0 .93.54V.45A.03.03 0 0 0 .9.42M.132.21l.04-.12h.137l.04.12zM.57.33h.21v.09H.57ZM.09.48h.78v.03H.09Zm.09.36H.12V.57h.33v.27Zm.66 0H.51V.57h.33Z" />
                                          <path d="M.54.645H.6v.12H.54zm-.18 0h.06v.12H.36z" />
                                        </g>
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.interiorsTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {interiorsList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg width="24" height="24" viewBox="0 0 1.92 1.92" xmlns="http://www.w3.org/2000/svg" fill="#666667">
                                        <path d="M.399 1.044h.225V.819H.399zM.523.842h.079v.079h-.08zm0 .101h.079v.079h-.08zM.422.842h.079v.079H.422zm0 .101h.079v.079H.422zm.488.101h.157V.819H.91zM1 .842h.045v.079H1zm0 .101h.045v.079H1zM.933.842h.045v.079H.933zm0 .101h.045v.079H.933zm.124.44H.832v.225h.225zm-.124.202H.854v-.079h.079zm0-.101H.854v-.079h.079zm.101.101H.955v-.079h.079zm0-.101H.955v-.079h.079z" />
                                        <path d="M1.842 1.496c-.002.001-.016.005-.029.014l-.021-.011v-.044l-.018.005a.1.1 0 0 0-.029.014.1.1 0 0 0-.029-.014l-.018-.005v.033l-.016.005c-.002.001-.016.005-.029.014L1.642 1.5v-.404l.007.004c.132.091.15-.063.136-.118-.027-.104.048-.13.069-.216.037-.154-.086-.239-.048-.386s-.088-.471-.25-.239c-.054.077-.119-.061-.204.057s-.041.221-.015.298c.052.154-.052.204.016.332s-.03.191.099.262c.042.023.063.023.078.014v.126l-.344-.095V.679h.084L1.017.518V.342h.028V.285H.848v.056h.028v.087L.652.285.09.679h.084v.473l-.114.092h.114v.503H.061v.113h1.795v-.112h-.038v-.136h.006a.036.036 0 0 0 .036-.036v-.085zM1.735.601a.057.057 0 0 1 0 .113c-.031 0 .018-.025.018-.057C1.753.626 1.704.6 1.735.6M1.686.297a.038.038 0 1 1 0 .076c-.021 0 .01-.017.01-.038s-.031-.038-.01-.038m0 .62a.042.042 0 0 1 0 .084c-.023 0 0-.019 0-.042s-.023-.042 0-.042M.848.678h.281v.45H.848zm-.618 0h.562v.45H.23zm.352.909a.016.016 0 1 1 0-.033.016.016 0 1 1 0 .033m.571.159H.621V1.44h.022v-.044H.38v.044h.022v.307H.23v-.503h.923zm.198-.162h-.028v-.079h.025v.067q0 .007.003.014m-.028-.101v-.079h.045v.079zm.039.022s.02.006.033.019a.1.1 0 0 1 .033-.019v.065a.02.02 0 0 1-.022.022h-.022a.02.02 0 0 1-.022-.022zm.027.241h-.18v-.504h.206v.252l-.02.011-.004-.003v-.121h-.157v.225h.156zm-.134-.263v-.079H1.3v.079zm.045.022v.079h-.045v-.079zm.114.241H1.4v-.089a.03.03 0 0 0 .014.014zm.034 0h-.011v-.07h.011zm.005-.084h-.022a.02.02 0 0 1-.022-.022v-.034a.04.04 0 0 0 .027-.017l.006.005a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022m.028.084H1.47v-.075l.011-.009zm-.006-.187a.02.02 0 0 1-.021-.022v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022h-.009v-.004zm.053.187h-.036v-.172h.006a.04.04 0 0 0 .023-.009v.01q0 .012.007.02zm0-.291-.012.003a.1.1 0 0 0-.029.014l-.016-.009v-.221h.057zm.17.116v-.025a.03.03 0 0 0 .015.021l-.014.008-.002-.001zM1.538.558c0 .023.023.042 0 .042a.042.042 0 1 1 0-.084c.023 0 0 .019 0 .042M1.537.243c.032 0-.015.026-.015.057s.047.057.015.057a.057.057 0 1 1 0-.114m-.133.202c0-.023.019-.042.042-.042s-.007.019-.007.042.03.042.007.042a.04.04 0 0 1-.042-.042m.108.395a.084.084 0 0 1 0-.169c.047 0-.018.038-.018.084s.065.084.018.084m.061.908h-.011v-.136h.011zm.029-.172q-.002.02-.022.022h-.022a.02.02 0 0 1-.022-.022V1.51s.02.006.033.019a.1.1 0 0 1 .033-.019v.066zm.018-.004v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.067a.02.02 0 0 1-.022.022h-.022a.02.02 0 0 1-.022-.022m.027.175h-.006v-.139h.006zm.048 0h-.037v-.09a.04.04 0 0 0 .032.02h.005zm-.005-.084a.02.02 0 0 1-.022-.022v-.034a.03.03 0 0 0 .026-.017l.006.005a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022zm.05.084h-.033v-.07h.006a.04.04 0 0 0 .028-.014zm-.005-.186a.02.02 0 0 1-.022-.022v-.066s.02.006.033.019a.1.1 0 0 1 .033-.019v.066a.02.02 0 0 1-.022.022zm.074.186h-.057v-.172h.005l.01-.002v.003a.036.036 0 0 0 .036.036h.005v.136zm.038-.172c0 .012-.01.022-.022.022h-.022a.02.02 0 0 1-.022-.022v-.01a.04.04 0 0 0 .012-.026v-.025l.021.014a.1.1 0 0 1 .033-.019z" />
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.exteriorsTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {exteriorsList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                  <ListSubheader>
                                    <div className="flex items-center">
                                      <svg
                                        fill="#666667"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 0 0.96 0.96"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <title />
                                        <g data-name="Layer 2" id="Layer_2">
                                          <path d="M0.113 0.204a0.03 0.03 0 0 0 -0.008 0.03 0.639 0.639 0 0 0 0.136 0.24c0.022 0.024 0.045 0.046 0.067 0.066H0.24a0.03 0.03 0 0 0 -0.03 0.03v0.09a0.03 0.03 0 0 0 0.03 0.03h0.004L0.27 0.904a0.03 0.03 0 0 0 0.03 0.026h0.36a0.03 0.03 0 0 0 0.03 -0.026l0.026 -0.214H0.72a0.03 0.03 0 0 0 0.03 -0.03v-0.09a0.03 0.03 0 0 0 -0.03 -0.03h-0.07c0.022 -0.021 0.046 -0.043 0.068 -0.068a0.633 0.633 0 0 0 0.134 -0.24 0.03 0.03 0 0 0 -0.037 -0.036 0.477 0.477 0 0 0 -0.12 0.06A0.474 0.474 0 0 0 0.693 0.12a0.03 0.03 0 0 0 -0.047 -0.018 0.477 0.477 0 0 0 -0.09 0.098 0.471 0.471 0 0 0 -0.049 -0.124A0.028 0.028 0 0 0 0.48 0.06a0.03 0.03 0 0 0 -0.025 0.014 0.471 0.471 0 0 0 -0.05 0.128 0.483 0.483 0 0 0 -0.094 -0.1A0.03 0.03 0 0 0 0.263 0.12a0.465 0.465 0 0 0 0 0.134 0.462 0.462 0 0 0 -0.12 -0.057 0.03 0.03 0 0 0 -0.03 0.008M0.634 0.87H0.326l-0.022 -0.18h0.352ZM0.69 0.63H0.27v-0.03h0.42Zm-0.016 -0.198c-0.021 0.023 -0.042 0.044 -0.063 0.063l0.002 -0.004c0.007 -0.013 0.013 -0.027 0.02 -0.041l0.003 -0.006c0.007 -0.016 0.014 -0.03 0.02 -0.048s0.012 -0.032 0.018 -0.049a0.426 0.426 0 0 1 0.098 -0.069 0.564 0.564 0 0 1 -0.098 0.155m-0.035 -0.242a0.42 0.42 0 0 1 -0.02 0.131c-0.006 0.017 -0.012 0.034 -0.019 0.052l-0.011 0.027 -0.004 0.008 -0.007 0.017c-0.002 0.003 -0.003 0.007 -0.005 0.01s-0.004 0.01 -0.007 0.014 -0.003 0.007 -0.005 0.01 -0.004 0.009 -0.007 0.013l-0.005 0.01c-0.002 0.004 -0.004 0.008 -0.007 0.012l-0.005 0.009 -0.007 0.011c-0.002 0.003 -0.003 0.005 -0.005 0.007l-0.007 0.01c-0.002 0.002 -0.003 0.004 -0.004 0.006l-0.002 0.002h-0.019v-0.01c0 -0.01 0.003 -0.021 0.005 -0.032 0 -0.004 0.002 -0.008 0.002 -0.011 0.002 -0.008 0.003 -0.016 0.005 -0.024a0.96 0.96 0 0 1 0.035 -0.111c0.007 -0.018 0.014 -0.035 0.022 -0.052a0.423 0.423 0 0 1 0.073 -0.109M0.48 0.16a0.438 0.438 0 0 1 0.028 0.12 0.03 0.03 0 0 0 -0.002 0.005q-0.01 0.021 -0.018 0.043l-0.009 0.024q-0.004 -0.012 -0.009 -0.023c-0.005 -0.014 -0.011 -0.027 -0.017 -0.04l-0.002 -0.004A0.441 0.441 0 0 1 0.48 0.16m-0.086 0.144c0.007 0.015 0.014 0.03 0.02 0.048s0.014 0.037 0.02 0.055c0.002 0.006 0.003 0.011 0.005 0.017 0.003 0.011 0.007 0.022 0.009 0.032s-0.003 0.013 -0.004 0.02 -0.002 0.009 -0.003 0.013c-0.002 0.012 -0.004 0.023 -0.005 0.034a0.012 0.012 0 0 0 0 0.003l-0.002 -0.003q-0.009 -0.013 -0.017 -0.027l-0.002 -0.004c-0.005 -0.009 -0.011 -0.019 -0.016 -0.03l-0.003 -0.005c-0.006 -0.011 -0.011 -0.023 -0.017 -0.036 0 -0.002 -0.002 -0.005 -0.003 -0.007 -0.006 -0.013 -0.011 -0.026 -0.017 -0.04 -0.007 -0.018 -0.013 -0.036 -0.019 -0.053a0.423 0.423 0 0 1 -0.021 -0.13 0.432 0.432 0 0 1 0.076 0.114Zm-0.109 0.043 0.002 0.006a1.023 1.023 0 0 0 0.036 0.091 0.045 0.045 0 0 1 0.003 0.007c0.007 0.014 0.013 0.028 0.02 0.041l0.002 0.004c-0.021 -0.019 -0.042 -0.04 -0.063 -0.062a0.57 0.57 0 0 1 -0.099 -0.154 0.441 0.441 0 0 1 0.099 0.068" />
                                        </g>
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('app.professionalMode.gardensTitle')}</span>
                                    </div>
                                  </ListSubheader>
                                  {gardensList.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.code}>
                                        {t(`roomsList.${c.code}`)}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.styleTitle')}
                              </label>
                              <div className="d-flex flex-column">
                                <div className="upload-title">
                                  {styleSrc && (
                                    <div
                                      onClick={removeUploadedStyle}
                                      style={{ marginTop: '-30px', cursor: 'pointer' }}
                                      className="red-color"
                                    >
                                      <svg
                                        style={{ pointerEvents: 'none' }}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="14"
                                        height="14"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-trash text-[#9ca3af] hover:text-white transition"
                                      >
                                        <path d="M3 6L5 6 21 6"></path>
                                        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"></path>
                                      </svg>
                                    </div>
                                  )}
                                </div>
                                <div className="page-header mb-0 page-header-reset mb-2" />
                                {!styleSrc && (
                                  <div
                                    className={`pose-uploader-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                    onClick={handleStyleUpload}
                                  >
                                    <div className="uploader-title">
                                      <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M7 7L5.5 5.5M15 7L16.5 5.5M5.5 16.5L7 15M11 5L11 3M5 11L3 11M17.1603 16.9887L21.0519 15.4659C21.4758 15.3001 21.4756 14.7003 21.0517 14.5346L11.6992 10.8799C11.2933 10.7213 10.8929 11.1217 11.0515 11.5276L14.7062 20.8801C14.8719 21.304 15.4717 21.3042 15.6375 20.8803L17.1603 16.9887Z"
                                          stroke="#8c8c8c"
                                          strokeWidth="1.6"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <span style={{ marginLeft: '4px' }}>{t('home.stylePlaceHolder')}</span>
                                    </div>
                                  </div>
                                )}
                                {styleSrc && (
                                  <div
                                    className={`photographer-wrapper ${darkMode ? 'dark-border dark-bg-input' : 'light-border'}`}
                                    onClick={handleStyleUpload}
                                  >
                                    <div className="flex align-items-center">
                                      <img src={styleSrc} alt="Style Image" className="photographer-image" />
                                      <span className={`photographer-name ${darkMode ? 'text-white' : 'text-black'}`}>
                                        {t(`styles.${styleCode}`)}
                                      </span>
                                    </div>
                                    <span className="detail-btn">
                                      <svg
                                        fill="#757575"
                                        width="20px"
                                        height="20px"
                                        viewBox="-2.8 0 12.8 12.8"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="m1.6 8.8 2.4 -2.4 -2.4 -2.4 0.8 -0.8 3.2 3.2L2.4 9.6l-0.8 -0.8Z" />
                                      </svg>
                                    </span>
                                  </div>
                                )}
                              </div>
                              {currentLanguage === 'en' ? (
                                <>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <div className="sample-image-wrapper">
                                    <span>
                                      {t('app.professionalMode.customize')}
                                    </span>
                                  </div>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <TextField
                                    value={promptStyle}
                                    sx={{
                                      width: '100%',
                                      border: darkMode ? '1px solid #5d5d5d' : '',
                                      borderRadius: '6px',
                                      background: darkMode ? '#2a2a2a' : '',
                                      color: darkMode ? 'white' : 'black',
                                      fontSize: isMobile ? '16px' : '14px',
                                    }}
                                    maxRows={10}
                                    minRows={3}
                                    multiline
                                    onChange={handleInputChange}
                                    placeholder="A modern house..."
                                    inputProps={{
                                      style: {
                                        fontSize: isMobile ? '16px' : '14px',
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    InputLabelProps={{
                                      style: {
                                        fontSize: isMobile ? '16px' : '14px',
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    error={!!promptErrorMessage}
                                    helperText={promptErrorMessage}
                                  />
                                </>
                              ) : (
                                <>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <div className="sample-image-wrapper">
                                    <span>
                                      {t('app.professionalMode.enOnlyCustomize')}
                                    </span>
                                  </div>
                                  <div className="page-header mb-0 page-header-reset mb-2" />
                                  <TextField
                                    disabled={true}
                                    value={promptStyle}
                                    sx={{
                                      width: '100%',
                                      border: darkMode ? '1px solid #5d5d5d' : '',
                                      borderRadius: '6px',
                                      background: darkMode ? '#2a2a2a' : '',
                                      color: darkMode ? 'white' : 'black',
                                      fontSize: '14px',
                                    }}
                                    maxRows={3}
                                    minRows={3}
                                    multiline
                                    onChange={handleInputChange}
                                    placeholder="A modern house..."
                                    inputProps={{
                                      style: {
                                        fontSize: 14,
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    InputLabelProps={{
                                      style: {
                                        fontSize: 14,
                                        color: darkMode ? 'white' : 'black',
                                      },
                                    }}
                                    error={!!promptErrorMessage}
                                    helperText={promptErrorMessage}
                                  />
                                </>
                              )}
                              {/* <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.creativity')}
                              </label>
                              {renderStrength()}
                              <div className="page-header mb-0 page-header-reset mb-4" />
                              <label className={`${darkMode ? 'text-white' : 'text-black'}`}>
                                + {t('app.professionalMode.quantityTitle')}
                              </label>
                              <div className="page-header mb-0 page-header-reset mb-2" />
                              <FormControl sx={{ width: '100%' }}>
                                <Select
                                  sx={{
                                    border: darkMode ? '1px solid #5d5d5d' : '',
                                    borderRadius: '8px',
                                    background: darkMode ? '#2a2a2a' : '',
                                    color: darkMode ? 'white' : 'black',
                                    '& .MuiSvgIcon-root': {
                                      color: darkMode ? 'white' : 'black',
                                    },
                                    fontSize: '14px',
                                  }}
                                  value={currentResult}
                                  onChange={handleChangeResult}
                                  autoWidth
                                >
                                  {results.map((c, i) => {
                                    return (
                                      <MenuItem key={i} value={c.value}>
                                        {t(`results.${c.label}`)}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl> */}
                            </div>
                          </>
                        )}
                      </div>
                      <div className={`down-action-area ${darkMode ? 'dark-bg' : 'light-bg'}`}>
                        <div className="create-imagine-button generate-btn">
                          <Button onClick={onDesignProfessional} type="submit" className="generate-button w-button" loading={isCreating}>
                            <span style={{ marginLeft: '4px' }}>
                              {t('button.professional')}
                              <span>
                                {' '}
                                {'['}-
                                {/* <svg style={{marginTop: "-2px"}} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 291.764 291.764" width="12px"><g><path fill="#EFC75E" fillOpacity="1" d="M145.882,0c80.573,0,145.882,65.319,145.882,145.882s-65.31,145.882-145.882,145.882 S0,226.446,0,145.882S65.31,0,145.882,0z"></path><path fill="#CC9933" fillOpacity="1" d="M145.882,27.353c-65.465,0-118.529,53.065-118.529,118.529s53.065,118.529,118.529,118.529 s118.529-53.065,118.529-118.529S211.347,27.353,145.882,27.353z M145.882,246.176c-55.39,0-100.294-44.904-100.294-100.294 S90.493,45.588,145.882,45.588s100.294,44.904,100.294,100.294S201.281,246.176,145.882,246.176z M158.009,138.269 c-5.452-2.289-25.493-5.452-25.493-14.214c0-6.464,7.495-8.334,11.99-8.334c4.094,0,8.999,1.295,11.589,3.875 c1.641,1.577,2.316,2.726,2.854,4.313c0.684,1.869,1.094,3.875,3.684,3.875h13.357c3.136,0,3.957-0.574,3.957-4.021 c0-14.789-11.589-23.122-24.809-25.994V86.28c0-2.58-0.821-4.167-3.957-4.167h-10.64c-3.136,0-3.957,1.577-3.957,4.167v11.051 c-14.178,2.726-26.031,11.634-26.031,27.718c0,18.235,12.683,23.979,26.441,28.566c11.589,3.884,23.724,4.021,23.724,12.063 s-5.99,9.765-13.357,9.765c-5.051,0-10.631-1.304-13.366-4.741c-1.769-2.152-2.453-4.021-2.58-5.89 c-0.274-3.592-1.769-4.021-4.914-4.021H113.28c-3.136,0-3.957,0.729-3.957,4.021c0,16.366,13.093,26.286,27.262,29.441v11.206 c0,2.58,0.821,4.167,3.957,4.167h10.64c3.136,0,3.957-1.586,3.957-4.167v-10.905c16.084-2.453,27.125-12.209,27.125-29.441 C182.28,145.591,167.829,141.424,158.009,138.269z"></path></g></svg> */}
                                <svg
                                  style={{ marginTop: '-2px' }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 32 32"
                                  fill="#ffc337"
                                >
                                  <path d="M17.333 4v9.333h8L14.666 28v-9.333H6.667z" />
                                </svg>
                                {credits}
                                {']'}
                              </span>
                            </span>
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <AllShowCase
                  userData={userData}
                  checkCredits={checkCredits}
                  firebase={firebase}
                  currentJob={currentJob}
                  t={t}
                  jobsList={jobsList}
                  isCreating={isCreating}
                  progress={progress}
                  onGenFill={onGenFill}
                  onFetchUser={onFetchUser}
                  onUpImageResolution={handleOnUpImageResolution}
                  onRemoveBG={handleOnRemoveBG}
                  handleSelectCollection={handleSelectCollection}
                  onVirtualHome={onVirtualHome}
                  darkMode={darkMode}
                />
              </div>
            )}
            {showMyDesign && (
              <div className="right-area">
                <MyDesign
                  userData={userData}
                  checkCredits={checkCredits}
                  firebase={firebase}
                  t={t}
                  jobsList={jobsList}
                  isCreating={isCreating}
                  onGenFill={onGenFill}
                  onFetchUser={onFetchUser}
                  onUpImageResolution={handleOnUpImageResolution}
                  onRemoveBG={handleOnRemoveBG}
                  onVirtualHome={onVirtualHome}
                  darkMode={darkMode}
                />
              </div>
            )}
            {showReferal && (
              <div className="right-area">
                <Referal
                  firebase={firebase}
                  t={t}
                  jobsList={jobsList}
                  isCreating={isCreating}
                  onGenFill={onGenFill}
                  onFetchUser={onFetchUser}
                  userData={userData}
                />
              </div>
            )}
            {showEditor && (
              <div className="right-area-editor">
                <MainEditor
                  userData={userData}
                  firebase={firebase}
                  darkMode={darkMode}
                  isMobile={isMobile}
                  model={model}
                  userInputImage={file}
                  removeImageFromEditor={()=> setFile(null)}
                />
              </div>
            )}
          </div>
        </div>
      )}
      {/* {isShowPricing && currentLanguage === 'vi' && <Pricing t={t} currentLanguage={currentLanguage} userData={userData} firebase={firebase} onShowPricing={onShowPricing} onFetchUser={onFetchUser} />} */}
      {isShowPricing && (
        <NewPricing
          t={t}
          currentLanguage={currentLanguage}
          userData={userData}
          firebase={firebase}
          onShowPricing={onShowPricing}
          onFetchUser={onFetchUser}
        />
      )}
      {isSpinning && <Spinner />}
      {/* {showGenFillEditor && (
        <EditImage
          checkCredits={checkCredits}
          imageUrl={imageUrlEditor}
          onClose={onCloseImageEdit}
          firebase={firebase}
          t={t}
          onGenFill={onGenFill}
          onChangeImageSrc={onChangeImageSrc}
          onFetchUser={onFetchUser}
        />
      )} */}
      {isShowPose && (
        <Pose
          t={t}
          currentLanguage={currentLanguage}
          userData={userData}
          firebase={firebase}
          onShowPose={onShowPose}
          onFetchUser={onFetchUser}
          posesList={currentPoses}
          uploadedPosesList={uploadedPosesList}
          handleSelectPose={handleSelectPose}
          handleSetPoseFile={handleSetPoseFile}
          onShowPricing={onShowPricing}
        />
      )}
      {/* {isShowBackground && <Background t={t} currentLanguage={currentLanguage} userData={userData} firebase={firebase} onShowBackground={onShowBackground} onFetchUser={onFetchUser} backgroundsList={backgrounds} handleSelectBackground={handleSelectBackground} onShowPricing={onShowPricing} submitPrompt={submitPromptBG} promptBG={promptBackground}/>} */}
      {isShowStyle && (
        <Style
          t={t}
          currentLanguage={currentLanguage}
          userData={userData}
          firebase={firebase}
          promptStyle={promptStyle}
          onShowStyle={onShowStyle}
          onFetchUser={onFetchUser}
          stylesList={styles}
          handleSelectStyle={handleSelectStyle}
          onShowPricing={onShowPricing}
          submitPrompt={submitPromptStyle}
        />
      )}
      {isShowPhotographer && (
        <Photographer
          photographerInfo={photographerInfo}
          t={t}
          currentLanguage={currentLanguage}
          userData={userData}
          firebase={firebase}
          onShowStyle={onShowPhotographer}
          onFetchUser={onFetchUser}
          handleSelectPhotographer={handleSelectPhotographer}
          onShowPricing={onShowPricing}
        />
      )}
      <Feedback isOpen={showFeedbackModal} onClose={() => setShowFeedbackModal(false)} isSubmitted={isSubmittedFeedback} onSubmitted={handleSubmittedFeedback} currentLanguage={currentLanguage} t={t} userData={userData} engine={firebase}/>
    </div>
  );
};

export default NewHome;
